export const translation_ptBR = {
  diveEditDashboard: "Mergulhe na edição de painéis.",
  passwordNotMatch: "A senha não corresponde",
  successChangedPassword: "Sucesso! Você mudou sua senha",
  currentPassword: "Senha atual",
  newPassword: "Nova Senha",
  confirmNewPassword: "Confirme a nova senha",
  updatePassword: "Atualizar senha",
  pleaseInformPhoneNumber: "Por favor, informe seu telefone.",
  dataEditedSuccess: "Dados editados com sucesso",
  myData: "Meus dados",
  readingModePleaseContact:
    "Usuário Somente Leitura. Entre em contato com o usuário administrador da sua empresa para acessar as funcionalidades de edição",
  youCanOnlyChangeItems:
    "Você pode alterar apenas os itens que você mesmo criou.",
  actions: "Ações",
  showingResults: "Mostrando {{start}} a {{end}} de {{total}} resultados",
  previousPage: "Página anterior",
  nextPage: "Próxima página",
  firstPage: "Primeira página",
  lastPage: "Última página",
  page: "Página",
  of: "de",
  navBar: {
    operationInsight: "Eventos Operacionais",
    forecastCharts: "Previsões",
    sensorCharts: "Sensores",
    dynamicUkcCharts: "FAQ Dinâmica",
    alerts: "Alertas",
    mooringLines: "Amarração de navios",
    morphologyMap: "Mapa de morfologia",
    admin: "Admin",
    myData: "Meus dados",
    changePassword: "Mudar senha",
    userManager: "Gestão de usuários",
    notificationManager: "Gerenciador de notificações",
    forecastChecker: "Verificador de previsão",
    settings: "Configurações",
    errorWhileGetMooringAuthentication:
      "Oops! Erro ao obter autenticação de ancoragem! Entre em contato conosco.",
    logout: "Sair",
    portuguese: "Português",
    english: "Inglês",
    spanish: "Espanhol",
    shareForecast: "Compartilhar previsão",
    new: "Novo",
    shareForecastWithOutLeaving: "Compartilhe a previsão sem sair do i4cast!",
    reportOccurrence: "Reportar ocorrência",
    occurrences: "Ocorrências",
    importOccurrence: "Importar ocorrência",
    youAreGoingToBeRedirect: "Você será redirecionado para outra página",
    errorWhileGetUKCAuthentication:
      "Oops! Erro ao obter autenticação do FAQ dinâmico! Entre em contato conosco.",
    manageStation: "Gestão de estações",
    performance: "Performance",
    eventHistory: "Histórico de eventos",
    eventAnalysis: "Análise de eventos",
    watchTutorial: "Assistir tutorial",
    learnHowToUse: "Aprenda a Utilizar o i4cast",
    riverForecast: "Previsões de rio",
    services: "Serviços",
    locations: "Localidades",
  },
  login: {
    usernameNoLongerValid:
      "Desculpe, esse usuário foi desativo e não é mais valido",
    passwordNotBeenChanged:
      "A senha não foi alterada. Repita a operação ou entre em contato com contato@i4sea.com",
    errorValidatingPassword: "Erro ao validar a sua senha atual",
    resetPassword: "Recuperar senha",
    logIn: "Log in",
    verificationCodeSent: "Código de verificação enviado!",
    successWeveSentYouEmailPasswordReset:
      "Sucesso! Enviamos um e-mail para você com instruções de redefinição de senha.",
    doneNewPasswordSaved: "Feito! Nova senha salva",
    successGoBackToLogin:
      "Sucesso! Retorne para o login e seja bem-vindo de volta.",
    login: {
      usernameNoLongerValid:
        "Desculpe, esse usuário foi desativo e não é mais valido",
      updateI4castData: "Atualize seus dados para maximizar o uso do i4cast",
      resetPassword: "Recuperar senha",
      gotIt: "Entendi!",
      skip: "pular",
      emailUsername: "Email ou usuário",
      password: "Senha",
      keepLogged: "Mantenha-me conectado",
      userPasswordIncorrect:
        "O usuário ou a senha não estão corretos. Recuperar a sua ",
      logIn: "Entrar",
      forgotUsername: "Esqueci o usuário?",
      forgotPassword: "Esqueceu a senha?",
      alert: "Alerta",
      verificationCodeSent: "Código de verificação enviado!",
      successWeveSentYouEmailPasswordReset:
        "Sucesso! Enviamos um e-mail para você com instruções de redefinição de senha.",
      doneNewPasswordSaved: "Feito! Nova senha salva",
      successGoBackToLogin:
        "Sucesso! Retorne para o login e seja bem-vindo de volta.",
      itAppearsYouAreDisconnected:
        "Parece que você está desconectado. Por favor, verifique sua conexão com a internet.",
      sorryWeSeemToHaveEncountered:
        "Desculpe-nos, parece que encontramos um problema em nosso servidor. Por favor, tente novamente mais tarde.",
      hidePassword: "Esconder senha",
      showPassword: "Mostrar senha",
      eyesClosed: "Olho fechado",
      eyesOpen: "Olho aberto",
    },
    forgotPassword: {
      recoverPassword: "recuperar senha",
      next: "Próximo",
      cancel: "Cancelar",
      thereWasProblem: "Ocorreu um problema",
      pleaseInputEmail: "Por favor, insira seu e-mail!",
      updatePassword: "Atualizar senha",
      newPassword: "Nova Senha",
      pleaseCheckEmail: "Por favor, verifique sua caixa de e-mail",
      enterCodeVerification: "Digite seu código de verificação",
      pleaseInputVerificationCode: "Insira seu código de verificação",
      pleaseInputYourPassword: "Por favor insira sua senha",
      pleaseInputYourNewPassword: "Por favor insira sua nova senha",
      pleaseInputYourNewPasswordAgain: "Insira sua nova senha novamente",
      confirmNewPassword: "Confirme a nova senha",
    },
    changePassword: {
      changePassword: "Mudar senha",
      updatePassword: "Atualizar senha",
      newPassword: "Nova Senha",
      cancel: "Cancelar",
      dataEditedSuccess: "Dados editados com sucesso",
      currentPassword: "Senha atual",
      pleaseInputCurrentPassword: "Por favor insira sua senha atual",
      pleaseInputYourNewPassword: "Por favor insira sua nova senha",
      pleaseInputYourNewPasswordAgain: "Insira sua nova senha novamente",
      confirmNewPassword: "Confirme a nova senha",
      passwordNotMatch: "A senha não corresponde",
      success: "Successo",
      error: "Erro",
    },
    newPasswordForm: {
      verificationCode: "Código de verificação",
      newPassword: "Nova Senha",
      resetPassword: "Redefinir senha",
      returnToLogin: "Voltar ao login",
      verificationCodePasswordIncorrect:
        "Código de verificação ou senha incorretos.",
    },
    recoverPasswordForm: {
      typeYourEmail: "Digite seu e-mail",
      sendInstructionsByEmail: "Enviar instruções por e-mail",
      emailIncorrect: "E-mail incorreto.",
      returnToLogin: "Voltar ao login",
    },
    signIn: {
      alert: "Alerta",
      updateI4castData: "Atualize seus dados para maximizar o uso do i4cast",
      gotIt: "Entendi!",
      skip: "pular",
      thereWasAProblemWithLogin:
        "There was a problem with the login, check your credentials.",
      user: "Do utilizador",
      password: "Senha",
      logIn: "Conecte-se",
      forgotPassword: "Esqueceu a senha?",
    },
  },
  notificationManager: {
    pleaseEnterMessageTitle: "Insira um título de mensagem.",
    pleaseEnterMessageContent: "Por favor insira um conteúdo de mensagem.",
    confirm: "confirme",
    confirmPushNotificationSent:
      "Confirmar notificação push enviada para {{totalUsers}} usuários-alvo?",
    send: "Mandar",
    cancel: "Cancelar",
    selectCompany: "Selecione uma empresa",
    next: "Próximo",
    previous: "Anterior",
    sendPushNotification: "Enviar notificação push",
    pushNotificationSentSuccessfully: "Notificação push enviada com sucesso",
    submissionFailed: "Falha no envio",
    checkModifingInformationResubmiting:
      "Verifique e modifique as seguintes informações antes de reenviar.",
    tryAgain: "Tente novamente",
    allClearYouDontHaveNewMessages:
      "Tudo limpo! Você não tem nenhuma mensagem nova.",
    unreadNotification: "Notificação não lida",
    markAllAsRead: "Marcar tudo como lido.",
    notifications: "Notificações",
    sendNewPushes: "Enviar novos pushs",
  },
  oceanWeatherIntelligence: {
    errorGeneratingInsight:
      "Ops! Houve um problema ao gerar os eventos para essa localização e alguns deles ficaram inacessíveis. Por favor entre em contato para mais informações",
    errorGetChartData:
      "Erro ao buscar dados para o gráfico. Por favor entre em contato.",
    environmentalVariablesNotFound:
      "Ooops! Variáveis ambientais não encontradas para essa localização!",
    insightIsCausedBy: "O evento é causado por:",
    end: "Fim",
    start: "Início",
    summary: "Resumo",
    to: "até",
    rare: "Muito baixa",
    low: "Baixa",
    medium: "Média",
    high: "Alta",
    almostCertain: "Muito Alta",
    probability: "Probabilidade",
    locationInsight: "Localidade/Evento",
    riskExtreme: "Risco extremo",
    riskHigh: "Risco elevado",
    riskModerate: "Risco moderado",
    riskLow: "Risco baixo",
    probabilityRisk: "Probabilidade",
    severity: "Severidade",
    riskMatrix: "Matriz de risco",
    impactedArea: "da área impactada",
    point: "Ponto",
    area: "Área",
    processing: "processando",
    error: "erro",
    // workspace#385 (US2): o que uma linha de area diz quando nao desenha barra.
    // Sao SEIS estados e cinco rotulos: `ready` desenha barra e nao precisa de
    // texto. notPlanned NUNCA pode ler como "nao ocorre" -- e esse o defeito que
    // a historia existe para fechar.
    rowState: {
      // ⚠️ Em INGLES nos tres idiomas, de proposito (decisao do time, 11/09/2026).
      // 📖 Esta frase era o marcador que o backend concatenava no NOME do evento
      // (`[No upcoming events!]`), entao e o texto que os usuarios ja liam em
      // qualquer idioma. Agora que o marcador saiu do nome, o rotulo abaixo e o
      // unico lugar que a diz -- e a diz com as mesmas palavras de antes.
      doesNotOccur: "No upcoming events!",
      neverWarms: "sem modelo para as variáveis",
      calculating: "calculando",
      // ⚠️ `notPlanned` diz "calculando" DE PROPOSITO, igual ao estado acima.
      // Os dois seguem distintos no payload (`rowState`), e so ali: para quem le
      // a tela, "um job esta rodando" e "nenhuma passagem chegou nesta regra"
      // significam a mesma coisa -- espere, vai aparecer. Decisao de produto de
      // 10/09/2026, depois de "ainda nao avaliado" ser lido como "abandonado".
      // 📖 O custo: o sinal de um pipeline travado sai da TELA e passa a viver no
      // log e no campo da API -- que e onde quem pode agir sobre ele olha.
      notPlanned: "calculando",
      unavailable: "não foi possível verificar",
      // aurora#1619: Gantt de data passada sem resultado para aquela data (antes de o
      // motor servir areas, ou lacuna nas passagens dele). ⚠️ Nao pode ler como
      // `doesNotOccur` (seria afirmar que o tempo estava bom) nem como `calculating`
      // (esperar nao resolve).
      pastUnavailable: "sem cálculo para esta data",
    },
    errorWhileSaveSort:
      "Ocorreu um erro ao salvar a ordenação. Entre em contato conosco.",
    errorSortListPermission:
      "Você não tem permissão para ordenar a lista. Entre em contato com o administrador.",
    errorWhileFavoriteDashboard:
      "Ocorreu um erro ao favoritar painel. Entre em contato conosco.",
    oceanWeatherIntelligence: {
      clickGoBackPastInsights: "Histórico de eventos",
      needSelectDashboardPastInsight:
        "Ops! Você precisa selecionar um painel para voltar à previsão anterior",
      diveOperationInsights: "Mergulhe nos eventos operacionais.",
      editDashboard: "Editar painel",
      selectDashboard: "Selecione um painel",
      needSelectDashboardAddLocation:
        "Ops! Você precisa selecionar um painel para adicionar um local",
      editLocation: "Editar localização",
      editInsight: "Editar evento",
      currentInsight: "Evento atual",
      videoTutorials: "Vídeos tutoriais",
      time: "Horário:",
      operationInsights: "Eventos operacionais",
      eventManager: "Gerenciador de eventos",
      selectDashboardInsight:
        "Selecione um painel para visualizar seus eventos",
      dashboards: "Painéis",
      locations: "Localizações",
      insights: "Eventos",
      weStillDontHaveAnyDashboard: "Ainda não temos nenhum painel cadastrado.",
      letsGo: "Vamos lá?",
      addLocation: "Adicionar Localização",
      dashboardNoEventsTitle: "Painel ainda sem eventos...",
      dashboardNoEventsDescription:
        "Para visualizar o gráfico, crie o primeiro evento do painel",
      addLocationInsightToYourDashboard:
        "Para visualizar o Gráfico adicione uma localização. Clique em 'Adicionar Localização' para começar. 😉",
      almostThereCreateInsightVisualizeChart:
        "Quase lá! Para criar um Evento e visualizar o gráfico",
      clickHere: "clique aqui",
      selectService: "Selecione um serviço",
      showShifts: "Exibir no gráfico",
      serviceShift: "Turno do serviço",
      until: "até",
      createServiceAndVisualize:
        "Cadastre um serviço e visualize junto ao gráfico de eventos",
      createService: "Cadastrar serviço",
      newService: "Novo!",
      showServiceChart: "Exibir serviço no gráfico",
      selectAserviceToView:
        "Selecione um serviço para visualizar seus turnos no gráfico de Gantt, junto com eventos de previsão para melhor planejamento.",
      probability: "PROBABILIDADE",
      total: "Total",
      insightsWithProbability:
        "Fica a dica: quando você ver [Probabilidade] a chance de ocorrência do evento está disponível.",
      checkTheRiskLevels:
        "Veja como as cores de riscos dos eventos são representados na matriz de risco.",
      clickToLearnMore: "Veja como funciona!",
      probabilitySwitch: "Probabilidade",
      whenYouDisable:
        "Desabilita as probabilidades dos eventos do gráfico, exibindo de forma determinística.",
      leaveYourFeedback: "Deixe seu feedback",
      notUsefulAtAll: "1 - Nada útil",
      veryUseful: "5 - Muito útil",
      thanksForFeedback: "Obrigado pelo seu feedback! 🙌",
      close: "Fechar",
      errorSortingList: "Erro ao ordenar lista",
      thereAreInsightsWithErrors:
        "Não foi possível gerar um ou mais eventos de área. Tente ajustar as condições ou reposicionar a área no mapa. Se o problema persistir, entre em contato com o suporte.",
    },
    insightAlert: {
      alertRemovalFailed: "A remoção do alerta falhou. Contate-nos",
      selectDashboardFilterLocation:
        "Selecione um painel para filtrar a localização",
      alert: "Alerta",
      active: "Ativo",
      insight: "Evento",
      location: "Localização",
      dashboard: "Painel",
      filterDashboard: "selecionar um painel",
      filterLocation: "Selecionar um local",
      createNewAlert: "Criar novo alerta",
      delete: "Deletar",
      selectRecipient: "Selecione um destinatário",
      users: "Usuários",
      userName: "usuário",
      addAlert: "Adicionar Alerta",
      editAlert: "Editar Alerta",
      add: "Adicionar",
      edit: "Editar",
      cancel: "Cancelar",
      alertName: "Nome do Evento",
      alertTitleColumn: "Título do Alerta",
      eventColumn: "Evento",
      pleaseInputAlertName: "Insira o nome do evento!",
      alertNameExceedCharactersLimit:
        "O nome do evento excede o limite de 100 caracteres!",
      status: "Status",
      selectDashboardFromList: "Selecione um painel da lista!",
      selectLocationFromList: "Selecione um local da lista!",
      selectInsightFromList: "Selecione um evento da lista!",
      upTo: "Tempo de antecedência",
      selectTimeBeforeEvent: "Selecione um horário antes do evento!",
      minutes: "minutos",
      hour: "hora",
      hours: "horas",
      day: "dia",
      days: "dias",
      notificationName: "Nome da Notificação",
      notificationNameExceedCharactersLimit:
        "O nome da notificação excede o limite de 100 caracteres!",
      description: "Descrição",
      inputLocationSummary: "Insira o resumo do local",
      minimunEventDuration: "Duração mínima do evento",
      eventTimeRange: "Intervalo de horas do evento",
      insightLocationTimezone: "*Timezone da localização do evento",
      otherConfigurationOptions: "Outras opções de configuração",
      configurationCommingSoon: "Esta configuração em breve",
      eventStart: "Início do evento",
      eventFinish: "Fim do evento",
      recipient: "Destinatário",
      errorGetUserAlert:
        "Erro ao buscar dados do usuário. Por favor entre em contato",
      errorGetDashboardAlert:
        "Erro ao buscar dados do painel. Por favor entre em contato",
      errorGetLocationAlert:
        "Erro ao buscar dados da localização. Por favor entre em contato",
      errorGetInsightAlert:
        "Erro ao buscar dados do evento. Por favor entre em contato",
      errorGetAlertsData:
        "Erro ao buscar dados do alerta. Por favor entre em contato",
      errorLoadingEnvironmentalVariables:
        "Erro ao carregar as variáveis ambientais. Verifique sua conexão e tente novamente.",
      retryLoadEnvVariables: "Tentar novamente",
      errorDeleteAlerts: "Erro ao deletar alerta. Por favor entre em contato",
      errorAddAlert: "Erro ao adicionar alerta. Por favor entre em contato",
      errorUpdateAlert: "Erro ao atualizar alerta. Por favor entre em contato",
      errorConflict:
        "Já existe um alerta com este template. Procure na lista abaixo para editá-lo.",
      insightAlerts: "Alertas",
      beforeEventsStart: "Antes do início do evento",
      notification: "Notificação",
      areYouSureWantDeleteThisAlert:
        "Tem certeza de que deseja excluir este alerta?",
      allUsers: "Todos usuários",
      yes: "Sim",
      no: "Não",
      valueRequired: "Valor é obrigatório",
      thisIsHasNoWhatsapp: "Este usuário não possui WhatsApp cadastrado",
      createFromTemplate: "Criar por um template",
      createFromScratch: "Criar por um evento",
      createCustomAlert: "Criar alerta personalizado",
      createdFromScratch: "Criado por um evento",
      linkedToInsight: "Vinculado a evento",
      alertsOver3Days:
        "Alertas acima de 3 dias têm maior chance de mudança ou cancelamento.",
      alertInfo: "Informações do alerta",
      alertTemplate: "Template do alerta",
      alertType: "Categoria de risco",
      insightBadge: "Evento",
      locationColumn: "Localidade",
      alertTemplateArea: "Área do alerta",
      exampleRisk: "Ex. risco de queda de container",
      alertConditions: "Condições do alerta",
      monitoredArea: "Área monitorada",
      locationType: "Tipo de Localização",
      point: "Ponto",
      pointDescription: "Ideal para monitorar eventos em um local específico.",
      area: "Área",
      areaDescription:
        "Ideal para monitorar eventos ao redor do seu local de interesse.",
      pointDetails: "Detalhes do Ponto",
      back: "Voltar",
      region: "Região",
      station: "Estação",
      pleaseSelectRegionFromList: "Por favor, selecione uma região da lista",
      pleaseSelectStationFromList: "Por favor, selecione uma estação da lista",
      deliveryChannel: "Canal de envio",
      enabledDeliveryChannels: "Canais de envios habilitados",
      atLeastOneChannelRequired: "Selecione pelo menos um canal de envio",
      userToReceiveAlert: "Usuários que receberão o alerta:",
      comingSoon: "em breve",
      new: "Novo",
      save: "Salvar alterações",
      saving: "Salvando...",
      invalidStationRegionFormat: "Formato de estação-região inválido",
      createAndCustomizeAlert:
        "Crie e personalize alertas para você e sua equipe e seja avisado de eventos climáticos importantes.",
      filter: "Filtro",
      port_closure: "Risco de fechamento de porto",
      extreme_wind: "Risco de vendaval",
      extreme_rain: "Risco de alagamento",
      rough_sea: "Risco de ressaca",
      no_category: "Sem categoria",
      tree_fall: "Risco de queda de árvores",
      roof_damage: "Risco de destelhamento",
      landslide: "Risco de deslizamento",
      extreme_heat: "Risco de calor extremo",
      wildfire: "Risco de incêndio florestal",
      fog: "Risco de neblina",
      low_visibility: "Risco de baixa visibilidade",
      lightning_storm: "Risco de incidência de raios",
      clear: "Limpar",
      filtrate: "Filtrar",
      filterList: "Filtrar na lista",
      searchByAlert: "Busque pelo nome do alerta",
      searchByUserName: "Busque pelo nome do usuário",
      duplicateAlertTemplate:
        "Você já possui um alerta com este template. Edite o alerta existente ou escolha outro template.",
      clickToLearnMore: "Veja como funciona!",
      withReady:
        "Com templates de alerta prontos, você escolhe uma área e acompanha",
      portClosureRisk:
        "riscos de fechamento de portos e risco operacional e estrutural",
      moreComingSoon: "(em breve outros).",
      whatIsAndHowItWorks: "O que é, e como funciona?",
      keepYourNumber:
        "Mantenha seu número atualizado para receber notificações em ritmo real.",
      gotIt: "Entendi",
      theBigDifference:
        "O grande diferencial deste novo alerta é o monitoramento por área da sua operação, além do envio direto no WhatsApp.",
      alertTitle: "Risco à segurança operacional, estrutural e ambiental",
      alertPeriod:
        "📅 Entre: <strong>Sábado (26) às 15h</strong> e <strong>11h Domingo (27)</strong>",
      environmentalConditionsTitle: "🌍 Condições ambientais:",
      environmentalConditionWaves: "• Ondas entre 3.5 e 4.5 m",
      environmentalConditionWinds: "• Ventos entre 28 e 35 nós",
      expectedImpactsTitle: "Descrição do alerta:",
      impactDamage: "• Danos a estruturas e equipamentos",
      impactSafety: "• Risco à segurança de pessoal",
      impactInterruption: "• Interrupção de operação",
      alertNote:
        "Alerta inicial. Seguimos monitorando e avisaremos em caso de mudanças ou cancelamento.",
      newAlertViaWpp: "Novos alertas via Whatsapp",
      exampleAlert: "Exemplo de alerta:",
      weVeRedesigned:
        "Reformulamos a central de alertas, e agora ela conta com alertas de risco por região com envio por Whatsapp,",
      // Template titles
      extremeHeatTitle: "Risco de calor extremo",
      extremeWindTitle: "Risco de vendaval",
      extremeRainTitle: "Risco de alagamento",
      landslideTitle: "Risco de deslizamento",
      wildfireTitle: "Risco de incêndio florestal",
      treeFallTitle: "Risco de queda de árvores",
      roofDamageTitle: "Risco de destelhamento",
      roughSeaTitle: "Risco de ressaca",
      fogTitle: "Risco de neblina",
      lowVisibilityTitle: "Risco de baixa visibilidade",
      lightningStormTitle: "Risco de atividade elétrica",
      noCategoryTitle: "Alerta operacional",
      portClosureTitle: "Risco de fechamento de porto",
      // Template descriptions
      extremeHeatDescription:
        "Temperaturas muito elevadas podem afetar equipes e operações.",
      extremeWindDescription:
        "Ventos fortes e rajadas intensas podem causar danos e interrupções.",
      extremeRainDescription:
        "Chuvas intensas elevam o risco de alagamentos e impacto em acessos.",
      landslideDescription:
        "Volume elevado de chuva aumenta o risco de deslizamentos.",
      wildfireDescription: "Tempo seco e vento favorecem a propagação do fogo.",
      treeFallDescription:
        "Solo encharcado e vento aumentam o risco de quedas.",
      roofDamageDescription:
        "Rajadas intensas podem causar danos em coberturas.",
      roughSeaDescription:
        "Ondas altas e mar agitado podem comprometer operações marítimas.",
      fogDescription:
        "Neblina pode reduzir a visibilidade e afetar a segurança.",
      lowVisibilityDescription:
        "Visibilidade reduzida pode impactar operações.",
      lightningStormDescription:
        "Tempestades com descargas elétricas organizadas aumentam o risco para pessoas, equipamentos e operações externas.",
      noCategoryDescription:
        "Condições ambientais fora do padrão foram identificadas. Avalie possíveis impactos na operação.",
      // Legacy descriptions (kept for backwards compatibility)
      possibilityOfImpacts:
        "Possíveis impactos em ativos e operações, com prioridade à segurança das equipes.",
      potentialSuspension:
        "Possibilidade de suspensão de manobras, atrasos logísticos e replanejamento de operações no terminal.",
      possibilityOfFlooding:
        "Possibilidade de alagamento com impactos em ativos e continuidade das operações.",
      customMessage: "Mensagem personalizada",
      alertTitleDescribe: "Título do alerta",
      alertTitlePlaceholder: "Título que será exibido no alerta",
      titleThatWillBe:
        "Título que será exibido no início da mensagem de alerta. Seja claro e objetivo.",
      alertDescription: "Descrição do alerta",
      alertDescriptionPlaceholder: "Descrição do alerta",
      describeTheImpact:
        "Descreva o impacto ou ações a serem tomadas pelo time.",
      viewMessage: "Ver mensagem",
      customizeMessage: "Personalizar mensagem",
      sendConfig: {
        title: "Configurações de envio",
        advanceTime: "Tempo de antecedência",
        selectPlaceholder: "Selecione",
        receipt: "Receber também",
        dayPeriodOfInterest: "Parte do dia que me interessa",
        eventCanBeCapturedAnytime:
          "O evento pode ser capturado em qualquer horário do dia",
        timezoneHelperText: "Timezone da localização do evento",
        eventCanBeCapturedBetween: "O evento pode ser capturado entre",
        minimumEventDuration: "Duração mínima do evento",
        minMaxAdvanceTime: "Tempo mínimo/máximo de antecedência",
        advanceTimeSubtitle:
          "O alerta capturado só será enviado se estiver dentro da janela mínima e máxima de antecedência.",
        alertsOver3DaysWarning:
          "Alertas acima de 3 dias têm maior chance de mudança ou cancelamento.",
        minMaxValidationError: "Tempo mínimo deve ser menor que tempo máximo",
        minGapValidationError: "Diferença mínima de 1 hora entre valores",
        selectedInterval: "Intervalo selecionado",
        receiptOptions: {
          sendUpdates: "Atualizações frequentes de evento",
          sendCancellations: "Cancelamentos de evento",
        },
      },
      alertIcon: "🚨 Alerta:",
      selectedUsers: "Usuários selecionados",
      channelMismatchWarning: "Atenção: Canais não verificados",
      someUsersDoNotHaveVerifiedChannels:
        "Alguns usuários selecionados não possuem todos os canais de envio verificados.",
      selectedChannelsNotVerified: "Canais selecionados sem verificação",
      usersWithoutChannelWillNotReceiveNotifications:
        "Os usuários sem o canal verificado não receberão notificações por esse canal.",
      goBack: "Voltar",
      saveAnyway: "Salvar mesmo assim",
      inLocation: "em",
      thisFieldRequired: "Este campo é obrigatório",
      continue: "Continuar",
      drawArea: "Desenhe uma área",
      importGeojson: "Importar GeoJSON",
      selectSavedArea: "Selecionar área salva",
      selectAreaAboveToVisualize: "Selecione a área acima para visualizar.",
      selectAlertType: "Selecione o tipo de alerta:",
      editYourArea:
        "Arraste os pontos azuis para editar o polígono. Clique em 'Confirmar' quando terminar.",
      drawYourArea:
        "Desenhe ponto a ponto os limites da sua área, cada clique corresponde a um dos limites.",
      confirmArea: "Confirmar",
      clearArea: "Limpar",
      invalidArea:
        "Posicione o polígono em uma área próxima das suas estações cadastradas.",
      invalidPoint:
        "Selecione um ponto em uma área próxima das suas estações cadastradas.",
      backToPrevious: "Voltar",
      selectStationOnMap: "Selecione uma estação no mapa.",
      selectPointOrStationOnMap:
        "Selecione um ponto existente aqui ou no mapa, ou clique diretamente para criar um novo.",
      searchStationOrCoordinates: "Buscar estação ou lat,lon",
      searchAcceptsCoordinates: "A busca aceita coordenadas lat/lon.",
      noResultsFound: "Nenhum resultado encontrado",
      customPoint: "Ponto Selecionado",
      saveStation: "Salvar estação",
      stationSaved: "Salva",
      stationName: "Nome da estação",
      stationNamePlaceholder: "Digite um nome para a estação",
      coordinates: "Coordenadas",
      stationSavedSuccess: "Estação salva com sucesso!",
      errorSavingStation: "Erro ao salvar estação",
      confirmPoint: "Confirmar",
      clearSelection: "Limpar seleção",
      selectPointOnMap: "Selecionar no mapa",
      selectedStation: "Estação selecionada",
      changeStation: "Alterar",
      type: "Tipo",
      group: "Grupo",
      addNewGroup: "Novo grupo",
      addNewCondition: "Nova condição",
      isGreaterThan: "é maior que",
      isEqualToOrGreaterThan: "é igual ou maior que",
      isEqualTo: "é igual a",
      isLessThan: "é menor que",
      isEqualToOrLessThan: "é igual ou menor que",
      and: "E",
      or: "OU",
      removeGroup: "Remover grupo",
      noMacroRegionOriginWasFound: "Não foi encontrada nenhuma macro região.",
      pleaseSelectPointOrArea: "* Por favor, selecione um ponto ou área.",
      pleaseDrawAnArea:
        "* Por favor, desenhe uma área no mapa ou importe uma existente.",
      selectAreaPlaceholder: "Selecione uma área...",
      successAlertCreated: "Alerta criado com sucesso!",
      errorCreatingAlert: "Erro ao criar alerta",
      andVerifyConditionTrueOrVerifyAtLeastConditionTrue:
        "E: Verifica se todas condições são verdadeiras. OU: Verifica se pelo menos uma das condições é verdadeira.",
      step1DataAndLocation: "Passo 1 - Dados e localidade",
      step1Location: "Passo 1 - Localidade",
      step1DataAndInsight: "Passo 1 - Dados e Evento",
      step2Conditions: "Passo 2 - Condições",
      step2Preferences: "Passo 2 - Preferências de envio",
      step3Preferences: "Passo 3 - Preferências de envio",
      createAlert: "Criar alerta",
      createEvent: "Criar evento",
      dropTheFile: "Solte o arquivo aqui...",
      dragAndDrop:
        "Arraste e solte um arquivo GeoJSON aqui ou clique para navegar.",
      saveArea: "Salvar área",
      areaSaved: "Área salva",
      areaName: "Nome da área",
      areaNamePlaceholder: "Digite o nome da área",
      requiredField: "Este campo é obrigatório",
      areaSuccessOnSave: "Sucesso! Sua área foi salva",
      errorCreatingArea: "Erro ao salvar área",
      areaNameAlreadyExists:
        "Já existe uma área com este nome. Por favor, escolha outro nome.",
      locationDataWarningTitle: "Atenção para as informações inseridas",
      locationDataWarningDescription:
        "Ao confirmar, os dados de localidade inseridos até o momento serão perdidos, deseja continuar?",
      yesWantToContinue: "Sim, quero continuar",
      alertTypeChangeWarningTitle: "Atenção para a mudança no tipo de alerta",
      alertTypeChangeWarningDescription:
        "Ao trocar o tipo de alerta, as condições serão substituídas pelas condições padrão do novo tipo. Deseja continuar?",
      alertTypeChangeChoiceDescription:
        "Ao mudar o tipo de alerta, as condições também mudam, deseja continuar de qual maneira?",
      alertTypeChangeDescription:
        "Ao mudar o tipo de alerta, as condições também mudam, deseja continuar de qual maneira?",
      keepCurrentConditions: "Manter minhas condições",
      useTemplateConditions: "Usar condições padrão",
      useTypeDefault: "Usar condições padrão",
      keepMyChanges: "Manter minhas condições",
      // Alert category tabs
      standaloneAlert: "Meu próprio alerta",
      insightAlert: "Vincular a um evento",
      selectAnInsight: "Selecione um evento",
      selectDashboard: "Painel",
      selectDashboardPlaceholder: "Selecione um painel...",
      selectInsight: "Evento",
      selectInsightPlaceholder: "Selecione um evento...",
      searchInsightPlaceholder: "Buscar evento...",
      noInsightsFound: "Nenhum evento encontrado",
      noInsightsInLocation: "Nenhum evento nesta localidade",
      selectedInsightConditions: "Condições do evento selecionado",
      eventAction: "Ação do evento",
      eventActionTooltip:
        "Define como as condições climáticas afetam sua operação. No modo Restritivo, as condições limitam ou impedem a operação. No modo Permissivo, as condições são necessárias para que a operação aconteça.",
      restrictive: "Restritivo",
      permissive: "Permissivo",
      conditionsPreview: "Pré-visualização das Condições",
      conditionPlaceholder: "A condição será exibida aqui",
      example: "Exemplo",
      selectInsightToSeeConditions:
        "Selecione um evento para ver suas condições",
      noConditionsAvailable: "Nenhuma condição disponível",
      insightAlertTitlePrefix: "Evento",
      monitoredLocation: "Localidade monitorada",
      monitoredAreaPolygon: "Área monitorada (polígono)",
      confirm: "Confirmar",
      condition: {
        and: "E",
        or: "OU",
      },
    },
    sensorAlert: {
      sectionTitle: "Alertas de sensores medidos",
      howItWorks: "Como funciona",
      newBadge: "Novo",
      // Spec 043 — Lightning support
      sensorTypeRainTab: "Chuva",
      sensorTypeLightningTab: "Raio",
      lightningPointPlaced: "Ponto de raio definido",
      lightningSelectionInfo:
        "A variável de raio funciona selecionando um ponto para monitorar.",
      lightningSelectionCallToAction:
        "Clique no mapa para definir o ponto de monitoramento do alerta.",
      lightningRadiusLabel: "Raio de monitoramento",
      lightningRadiusDescription:
        "Vamos utilizar o ponto selecionado como referência",
      lightningRadiusValue: "{{km}} km",
      clearLightningSelection: "Limpar seleção",
      lightningSilenceWindowLabel: "Janela de silêncio",
      lightningSilenceWindowHint:
        "Consideraremos o evento como encerrado após X tempo após o último raio.",
      lightningSilenceWindowOption: "{{min}} min",
      increase: "Aumentar",
      decrease: "Diminuir",
      removeRainAlert: "Remover alerta de chuva",
      removeLightningAlert: "Remover alerta de raio",
      removeRainAlertConfirmTitle: "Remover alerta de chuva?",
      removeRainAlertConfirmDescription:
        "Você perderá a seleção de sensores e as condições configuradas para chuva.",
      removeLightningAlertConfirmTitle: "Remover alerta de raio?",
      removeLightningAlertConfirmDescription:
        "Você perderá o ponto de monitoramento e a configuração do raio.",
      removeAlertConfirmButton: "Remover",
      noNearbySensorsButLightningAvailable:
        "Não há sensores próximos, mas você ainda pode configurar um alerta de raio.",
      // Tipo column on /insight-alerts table
      tipoColumn: "Tipo",
      chuvaLabel: "Chuva",
      raioLabel: "Raio",
      // Validation error messages mirrored from backend codes
      LIGHTNING_RADIUS_OUT_OF_RANGE:
        "Raio de monitoramento deve estar entre 1 e 100 km.",
      LIGHTNING_ALL_CLEAR_INVALID:
        "Janela de silêncio inválida. Valores aceitos: 1, 5, 10, 30 ou 60 min.",
      LIGHTNING_NOTIFICATION_INVALID:
        "Periodicidade inválida.",
      LIGHTNING_POINT_INVALID:
        "Coordenadas do ponto de raio inválidas.",
      LIGHTNING_ANCHOR_INVALID:
        "Âncora de estação inválida no alerta de raio.",
      howItWorksExampleTitle: "Exemplo de mensagem:",
      howItWorksExampleLine1: "Alerta de Sensor de chuva",
      howItWorksExampleLine2Bold: "Maior acumulado (24h): 35,3 mm",
      howItWorksExampleLine2Rest: " no sensor <nome sensor>",
      howItWorksExampleLine3Label: "Leitura dos sensores:",
      howItWorksExampleLine3Item1:
        " • 2 de 4 sensores ativos registraram chuva acumulada > 20 mm (24h)",
      howItWorksExampleLine3Item2: " • 1 sensor inoperante",
      howItWorksExampleLine4: "Alerta configurado no evento:",
      howItWorksExampleLine5: "Alagamento no boleto do trem em <localidade>",
      howItWorksTooltip:
        "Alertas de sensores medidos notificam você quando dados em tempo real de sensores físicos excedem as condições configuradas. Diferente dos alertas de previsão, estes são disparados por valores medidos reais.",
      sensorsAvailable: "{{count}} sensores disponíveis",
      sensorsAvailable_one: "{{count}} sensor disponível",
      suggestionText: "{{count}} sensores - raio de 30km",
      suggestionText_one: "{{count}} sensor - raio de 30km",
      suggestionFoundDescription:
        "Foram encontrados <b>{{count}}</b> sensores próximos da sua localidade.",
      suggestionFoundDescription_one:
        "Foi encontrado <b>{{count}}</b> sensor próximo da sua localidade.",
      suggestionCardSubtitle: "{{count}} em um raio de {{radius}}km",
      suggestionCardSubtitle_one: "{{count}} em um raio de {{radius}}km",
      viewNearbySensors: "Ver sensores próximos",
      createMyOwnWay: "Criar do meu jeito",
      disableAlert: "Desabilitar alerta",
      viewMessage: "Ver mensagem",
      selectedSensors: "{{count}} sensores selecionados",
      selectedSensors_one: "{{count}} sensor selecionado",
      emptyStateTitle: "Sem sensores próximos a localidade selecionada",
      emptyStateDescription:
        "Não há sensores de precipitação disponíveis nesta região.",
      errorLoadingSensors:
        "Erro ao carregar sensores. Por favor, tente novamente.",
      errorLoadingSensorEnvironmentalVariables:
        "Erro ao carregar as variáveis ambientais. Por favor, tente novamente.",
      retry: "Tentar novamente",
      disableAlertModalTitle: "Desabilitar alerta de sensor",
      disableAlertModalDescription:
        "Tem certeza que deseja desabilitar o alerta de sensor? Os sensores selecionados e as condições serão removidos.",
      disableAlertConfirm: "Desabilitar",
      disableAlertCancel: "Cancelar",
      closeAriaLabel: "Fechar",
      step3DisableModalTitle: "Aviso de alteração nas condições",
      step3DisableModalDescription:
        "Atualmente os dados de sensor estão habilitados apenas no evento com alerta. Ao desativar o alerta, você deixará de receber estas atualizações, deseja continuar?",
      step3DisableConfirm: "Desativar dados de sensor",
      step3DisableCancel: "Voltar",
      sensorConditionsEmptyStateTitle:
        "Adicione uma condição para acionar o alerta de sensor",
      sensorConditionsEmptyStateCreateButton: "Criar condição",
      singleSensorWarning:
        "Para melhor monitoramento em área do seu alerta recomendamos que selecione mais de 1 sensor.",
      sensorSelectionTitle: "Selecione os sensores de precipitação",
      sensorSelectionDescription:
        "Clique nos sensores para selecionar ou desselecionar.",
      sensorSuggestionReviewDescription:
        "Estes sensores foram sugeridos com base no raio de 30km. Você pode ajustar a seleção.",
      // Spec 043 — multi-type selection card (mirrors the new app)
      sensorSelectionTitleMulti: "Seleção de sensores",
      sensorSelectionSubtitleMulti:
        "Sensores de cada variável que gostaria de utilizar para o evento:",
      concludeConfiguration: "Concluir configuração",
      confirmSelection: "Confirmar",
      backToEvent: "Voltar",
      noSuggestionFound:
        "Não foram encontrados sensores na localidade selecionada,",
      createAlertOutsideLocation:
        "deseja criar um alerta com sensor fora da localidade?",
      createAlert: "Criar alerta",
      includeTitle: "Incluir alerta de dado medido?",
      viewSelectedSensorsTooltip: "Sensores selecionados:",
      editSensors: "Editar seleção de sensores",
      editSelection: "Editar seleção",
      howItWorksModalTitle: "Alerta adicional de sensor",
      howItWorksBody1:
        "Ao configurar um evento, você pode ir além das condições de previsão e incluir também um alerta de dados de sensores em tempo real.",
      howItWorksBody2Normal: "Ao ativar esta opção, você receberá",
      howItWorksBody2Bold:
        "alertas separados, um de previsão e outro de sensor.",
      periodicityLabel: "Periodicidade do alerta",
      periodicityRecurring: "Recorrente",
      periodicitySingle: "Único",
      frequencyLabel: "Receba atualizações a cada",
      frequencyHour_one: "{{count}} hora",
      frequencyHour: "{{count}} horas",
      recurringDescription:
        "Receba atualizações periódicas do sensor no intervalo definido, independentemente de mudanças",
      singleDescription:
        "Receba um alerta quando o valor ultrapassar o limite e outro quando voltar ao normal.",
      recurringTooltipTitle: "Envio Recorrente",
      recurringTooltip:
        "Receba atualizações periódicas do sensor no intervalo definido, independentemente de mudanças",
      singleTooltipTitle: "Envio Único",
      singleTooltip:
        "Receba um alerta quando o valor ultrapassar o limite e outro quando voltar ao normal.",
      templateModalTitle: "Visualizar mensagem",
      templateExampleLabel: "Exemplo de mensagem",
      templateAlertTitle: "Alerta de Sensor de chuva",
      templateMainReading:
        "Maior acumulado (24h): 35,3 mm no sensor {{sensorName}}",
      templateSensorReadingsTitle: "Leitura dos sensores:",
      templateSensorReadingsBullet:
        "{{activeSensors}} de {{totalSensors}} sensores ativos registraram {{condition}}",
      templateSensorReadingsExample:
        "Sensores ativos registraram chuva acumulada > 20 mm (24h)",
      templateInoperantSensors: "Sensores inoperantes: 1",
      templateEventLabel: "Alerta configurado no evento:",
      templateLocationPreposition: "em",
      templateExampleSensorName: "Sensor Exemplo",
      templateExampleEventName: "Nome do evento",
      templateExampleLocation: "Localidade",
      gotIt: "Entendi",
      pleaseAddSensorCondition:
        "* Por favor, adicione ao menos uma condição para o alerta de sensor.",
    },
    operationRule: {
      createDashboard: "Criar um novo painel",
      informNameForAdd: "Informe o nome para adicionar um novo painel.",
      informNameForEdit: "Informe o nome para edição.",
      removalFailedContactUs: "A remoção falhou. Contate-nos",
      diveIntoEditDashboard: "Mergulhe na edição de painéis.",
      operationInsight: "Eventos operacionais",
      dashboard: "Painel",
      name: "Nome",
      pleaseInformNameOfDashboard: "Informe o nome do painel.",
      informDashboardName: "Nome do painel",
      add: "Adicionar",
      newNameDashboard: "Novo nome do painel",
      save: "Salvar",
      cancel: "Cancelar",
      edit: "Editar",
      areYouSureWantDeleteDashaboard:
        "Tem certeza de que deseja excluir este painel?",
      delete: "Excluir",
      videoTutorials: "Vídeos tutoriais",
      errorToGetData:
        "Erro ao obter dados. Por favor, entre em contato conosco.",
      errorToAddData:
        "Erro ao adicionar dados. Por favor, entre em contato conosco.",
      needToInformIdForUpdateData:
        "Necessário informar ID para dados de atualização",
      errorToUpdateData:
        "Erro ao atualizar dados. Por favor, entre em contato conosco.",
      needInformIdForDeleteData: "Necessário informar ID para deletar dados",
      errorToDeleteData:
        "Erro ao excluir dados. Por favor, entre em contato conosco.",
      yes: "Sim",
      no: "Não",
      startCreatingFirstInsight:
        "Comece a criar o seu primeiro Evento adicionando um painel",
      editDashboard: "Editar painel",
      deleteDashboard: "Excluir Painel",
      areYouSureCantUndoThis:
        "Você tem certeza? {{dashboardName}} será removido!",
      newDashboard: "Novo Painel",
      search: "Pesquisar",
      dashboardSuccessOnSave: "Sucesso! Seu painel foi salvo",
    },
    operationRuleLocation: {
      youNeedSelectDashboardToAddLocation:
        "Ops! Você precisa selecionar um painel para adicionar um local",
      locationRemovalFailedContactUs: "A remoção do local falhou. Contate-nos",
      editLocation: "Editar localização",
      operationInsight: "Eventos operacionais",
      location: "Localização",
      diveEditDashboard: "Mergulhe no painel de edição.",
      selectDashboard: "Selecione um painel",
      addNewLocation: "Adicionar novo local",
      edit: "Editar",
      areYouSureWantDeleteLocation:
        "Tem certeza de que deseja excluir este local?",
      yes: "Sim",
      no: "Não",
      delete: "Excluir",
      videoTutorials: "Vídeos tutoriais",
      add: "Adicionar",
      cancel: "Cancelar",
      youNeed4AlphaNumericToTheKey:
        "Ops! Você precisa usar 4 caracteres alfanuméricos para a chave. ex: ABCD, ABC1, A1BC",
      name: "Nome",
      pleaseInputLocationName: "Por favor insira o nome do local!",
      key: "Chave",
      pleaseInputInitialNameLocation: "Insira o nome inicial do local!",
      inputLocationSummary: "Insira a descrição do local",
      region: "Região",
      pleaseSelectRegionFromList: "Selecione uma região",
      station: "Estação",
      pleaseSelectStationFromList: "Selecione uma estação",
      errorGetLocationData:
        "Erro ao buscar dados da localização. Por favor entre em contato.",
      errorAddLocationData:
        "Erro ao adicionar localização. Por favor entre em contato.",
      errorUpdateLocationData:
        "Erro ao atualizar localização. Por favor entre em contato.",
      errorDeleteLocationData:
        "Erro ao deletar localização. Por favor entre em contato.",
      summary: "Descrição",
      addNewLocationToYourDashboard:
        "Adicione uma nova localização para o seu painel.",
      deleteLocation: "Excluir Location",
      areYouSureCantUndoThis:
        "Você tem certeza? {{locationName}} será removido!",
      save: "Salvar",
      youNeedToFillAllTheFields: "Você precisa preencher todos os campos",
      locationSuccessOnSave: "Sucesso! Sua localização foi salva",
      stationNotFoundPleaseSelectValidStation:
        "Estação não encontrada. Por favor, selecione uma estação válida",
      point: "Ponto",
      pointDescription: "Ideal para monitorar eventos em um local específico.",
      area: "Área",
      areaDescription:
        "Ideal para monitorar eventos ao redor do seu local de interesse.",
      locationType: "Tipo de Localização",
      monitoredLocation: "Localidade monitorada",
      pointDetails: "Detalhes do Ponto",
      back: "Voltar",
      monitoredArea: "Área monitorada",
      drawArea: "Desenhe uma área",
      selectSavedArea: "Selecionar área salva",
      importGeojson: "Importar GeoJSON",
      pleaseDrawAnArea:
        "* Por favor, desenhe uma área no mapa ou importe uma existente.",
      selectAreaPlaceholder: "Selecione uma área...",
      thisFieldRequired: "Este campo é obrigatório",
      selectAreaAboveToVisualize: "Selecione a área acima para visualizar.",
      dragAndDrop:
        "Arraste e solte um arquivo GeoJSON aqui, ou clique para procurar.",
      dropTheFile: "Solte o arquivo aqui...",
      saveArea: "Salvar área",
      areaSaved: "Área salva",
      clear: "Limpar",
      invalidArea:
        "Posicione o polígono em uma área próxima das suas estações cadastradas.",
      confirmLocationTypeChange: "Edição de evento em área",
      areaEventEditing: "Edição de evento em área",
      changePointToAreaWarning:
        "Ao confirmar, este evento demorará alguns minutos para ser reexibido nos Eventos Operacionais, deseja continuar?",
      yesIWantToContinue: "Sim, desejo continuar",
    },
    operationRuleLocationInsight: {
      youNeedSelectLocationToEditInsight:
        "Ops! Você precisa selecionar um local para editar um evento",
      locationRemovalFailedContactUs: "A remoção do local falhou. Contate-nos",
      youNeedSelectLocationToAddInsight:
        "Ops! Você precisa selecionar um local para adicionar um novo evento",
      editInsight: "Editar Eventos",
      operationInsight: "Eventos operacionais",
      insight: "Evento",
      diveEditDashboard: "Mergulhe na edição de painéis.",
      selectLocation: "Selecione um local",
      addNewInsight: "Adicionar novo evento",
      edit: "Editar",
      areYouSureWantDeleteInsight:
        "Tem certeza de que deseja excluir este evento?",
      delete: "Excluir",
      videoTutorials: "Vídeos tutoriais",
      informGroupConditionInsight:
        "Ops! Informe um grupo de pessoas sobre esse evento.",
      informConditionGroupsInsight:
        "Ops! Informe uma condição nos grupos deste evento.",
      errorCriticalUpdateGroupConditions:
        "Erro crítico nas condições do grupo de atualização. Por favor, entre em contato conosco!",
      add: "Adicionar",
      name: "Nome",
      restrictionType: "Restritivo",
      noRestrictionType: "Permissivo",
      insightType: "Tipo de evento",
      tooltipRestrictionType:
        "Escolha o tipo de evento de acordo com as condições do evento: restritivas ou permissivas.",
      pleaseInputInsightName: "Insira o nome do evento!",
      stopNavigationForSmallBoats: "Parar a navegação para pequenos barcos",
      high: "Alto",
      medium: "Médio",
      low: "Baixo",
      pleaseEnterSummary: "Insira um descrição",
      theNavigationShouldStoppedWindsTooStrong:
        "A navegação deve ser interrompida porque os ventos estão muito fortes",
      conditions: "Condições",
      conditionsInsideConditionGroupShouldHaveSameLogicalOperator:
        "As condições dentro do grupo de condições devem ter o mesmo operador lógico. Se você quiser operadores lógicos diferentes, adicione outro grupo",
      pleaseSelectEnvironmentalVariable: "Selecione uma variável ambiental",
      isGreaterThan: "é maior que",
      isEqualToOrGreaterThan: "é igual ou maior que",
      isEqualTo: "é igual a",
      isLessThan: "é menor que",
      isEqualToOrLessThan: "é igual ou menor que",
      pleaseEnterValue: "Por favor, insira o valor!",
      addNewCondition: "Nova condição",
      removeGroup: "Remover grupo",
      addNewGroup: "Novo grupo",
      errorWhileGetDataForInsights:
        "Erro ao tentar obter dados para eventos. Por favor, entre em contato conosco.",
      errorWhileAddInsight:
        "Erro ao tentar adicionar evento. Por favor, entre em contato conosco.",
      internalErrorToUpdateData:
        "Erro interno ao atualizar os dados. Por favor, entre em contato conosco.",
      errorDeleteInsight:
        "Erro ao excluir o evento. Por favor, entre em contato conosco.",
      yes: "Sim",
      no: "Não",
      cancel: "Cancelar",
      error: "Erro",
      insightsProcessing:
        "Eventos em área precisam de um tempo para ser processado, ao finalizar você será avisado aqui e no seu email.",
      details: "Detalhes",
      priority: "Prioridade",
      summary: "Descrição",
      location: "Localização",
      and: "E",
      or: "OU",
      weReAlmostTheNowRegisterInsight:
        "Estamos quase lá! Agora você só precisa cadastrar o seu primeiro evento",
      group: "Grupo",
      type: "Tipo",
      youNeedToFillAllTheFields:
        "Você precisa preencher todos os campos obrigatórios",
      addNewConditionGroupInsight:
        "Adicione um novo grupo de condições climáticas para cadastrar seu evento",
      save: "Salvar",
      andVerifyConditionTrueOrVerifyAtLeastConditionTrue:
        "E: Verifica se todas condições são verdadeiras. OU: Verifica se pelo menos uma das condições é verdadeira.",
      groupsAreConditionsAddOneConditions:
        "Os grupos são conjuntos de condições climáticas. Adicione pelo menos uma condição climática para cada grupo criado",
      nameRequired: "Nome é obrigatório",
      summaryRequired: "Resumo é obrigatório",
      valueRequired: "Valor é obrigatório",
      insightSuccessOnSave: "Sucesso! Seu Evento foi salvo",
      deleteGroup: "Excluir grupo",
      areYouSureWantDeleteGroup: "Tem certeza que deseja excluir esse grupo ?",
      windAndGustProbabilities:
        "As probabilidades de vento e rajada estarão disponíveis após a próxima atualização da previsão.",
      continue: "Continuar",
      back: "Voltar",
      gotIt: "Entendi",
      operationImpactSeverity: "Severidade do impacto na sua operação",
      whatIsAndHowItWorks: "O que é, e como funciona?",
      example: "Exemplo",
      containerDropRiskInsight:
        "Um risco pode ser classificado como elevado mesmo que raro, como no caso de queda de contêiner, cuja severidade é gravíssima devido ao potencial de comprometer a segurança das pessoas envolvidas na operação.",
      informSeverityBasedOnImpact:
        "Informe a severidade de acordo com o impacto deste evento na sua operação.",
      selectSeverity: "Selecione a severidade",
      noImpact: "Sem impacto",
      minor: "Leve",
      moderate: "Médio",
      major: "Grave",
      severe: "Gravíssimo",
      insightSeverity: "Visualização de risco nos eventos",
      riskMatrixDescription:
        "A matriz de risco cruza a probabilidade de um evento com a severidade do impacto que ele pode causar. O i4cast destaca por cores os riscos mais importantes, ajudando você a agir com foco.",
      severityRequired: "Severidade é obrigatória",
      color: "Cor",
      colorOnDashboard: "Cor no painel",
      blue: "Azul",
      orange: "Laranja",
      yellow: "Amarelo",
      red: "Vermelho",
      registeredAlerts: "Alertas cadastrados",
      oneAlert: "1 alerta",
      multipleAlerts: "alertas",
    },
    insightManager: {
      insightManager: "Gerenciador de Eventos",
      dashboards: "Painéis",
      locations: "Localizações",
      insights: "Eventos",
      events: "Eventos",
      eventManager: {
        selectDashboard: "Selecionar Painel",
        selectedDashboard: "Painel selecionado",
        createDashboard: "Criar novo painel",
        noLocations: "Nenhum evento cadastrado para este painel",
        noEvents: "Nenhum evento cadastrado para esta localização",
        processing: "Processando",
        errorLoadingLocations: "Erro ao carregar localizações",
        errorLoadingEvents: "Erro ao carregar eventos",
        errorLoadingData: "Erro ao carregar localizações e eventos",
        eventReorderSuccess: "Ordem dos eventos atualizada com sucesso",
        eventReorderError: "Erro ao salvar ordem dos eventos",
        loadingEvents: "Carregando eventos...",
        eventsProcessingAlert: "Alguns eventos estão sendo processados",
        newEvent: "Novo evento",
        editEvent: "Editar evento",
        deleteEvent: "Excluir evento",
        editLocation: "Editar localização",
        deleteLocation: "Excluir localização",
        saveOrder: "Salvar ordem",
        cancelReorder: "Cancelar",
        options: "Opções",
        reorderEvents: "Reordenar eventos",
        reorderLocations: "Reordenar localizações",
        locationReorderSuccess: "Ordem das localizações atualizada com sucesso",
        locationReorderError: "Erro ao salvar ordem das localizações",
        deleteLocationTitle: "Deletar localização do painel",
        deleteLocationDescription:
          "Ao deletar uma localização com eventos, os eventos são deletados juntos no processo, deseja seguir com a ação?",
        deleteEventTitle: "Deletar evento",
        deleteEventDescription:
          "Deseja realmente excluir este evento? Esta ação não pode ser desfeita.",
        goBack: "Voltar",
        deleteAnyway: "Deletar mesmo assim",
        deleteLocationSuccess: "Localização excluída com sucesso",
        deleteLocationError: "Erro ao excluir localização",
        deleteEventSuccess: "Evento excluído com sucesso",
        deleteEventError: "Erro ao excluir evento",
        editLocationSuccess: "Localização atualizada com sucesso",
        editLocationError: "Erro ao atualizar localização",
        // Dashboard actions
        editDashboard: "Editar painel",
        deleteDashboard: "Excluir painel",
        favoriteDashboard: "Favoritar painel",
        unfavoriteDashboard: "Desfavoritar painel",
        editDashboardTitle: "Editar painel",
        deleteDashboardTitle: "Excluir painel",
        deleteDashboardDescription:
          'Ao excluir o painel "{{dashboardName}}", todas as localizações e eventos associados serão removidos. Deseja continuar?',
        dashboardName: "Nome do painel",
        dashboardNamePlaceholder: "Digite o nome do painel",
        save: "Salvar",
        dashboardUpdateSuccess: "Painel atualizado com sucesso",
        dashboardUpdateError: "Erro ao atualizar painel",
        dashboardDeleteSuccess: "Painel excluído com sucesso",
        dashboardDeleteError: "Erro ao excluir painel",
        dashboardFavoriteSuccess: "Painel favoritado com sucesso",
        dashboardUnfavoriteSuccess: "Painel desfavoritado com sucesso",
        dashboardFavoriteError: "Erro ao favoritar painel",
        dashboardCreatedSuccess: "Painel criado com sucesso",
        errorCreatingDashboard: "Erro ao criar painel",
        create: "Criar",
        cancel: "Cancelar",
        requiredField: "Campo obrigatório",
      },
    },
  },
  registerUser: {
    errorWhileLoadUserAreaOptions:
      "Erro ao carregar as opções da área do usuário",
    youHaveSuccessfullyRegistered:
      "Uhuuul! Você foi cadastrado com sucesso e já pode realizar o seu login!",
    errorWhileRegisterUser: "Erro ao cadastrar usuário",
    expiredInvitation: "convite expirado",
    sorryThePageYouVisitedNotExist:
      "Desculpe, a pagina que você visitou não existe mais",
    youInvitedJoinI4cast: "Você foi convidado para se juntar ao i4cast®!",
    invitedBy: "Convidado por",
    name: "Nome",
    pleaseInputYourName: "Por favor informe seu nome",
    nameMustContainOnlyLetters: "Nome deve conter apenas letras",
    lastName: "Sobrenome",
    pleaseInputYourLastName: "Por favor informe seu sobrenome",
    lastNameMustContainOnlyLetters: "Sobrenome deve conter apenas letras",
    username: "Usuário",
    pleaseInputYourUsername: "Por favor informe seu usuário!",
    lastNameMustStartWithLetter:
      "Deve começar com uma letra, conter apenas caracteres alfanuméricos, '_' e '.",

    usernameAlreadyHasAccount: "Usuário já possui uma conta no i4cast",
    password: "Senha",
    pleaseInputPassword: "Por favor informe sua senha!",
    passwordMustContain: "Deve conter pelo menos 6 dígitos e uma letra",
    phone: "Telefone",
    jobArea: "Setor de trabalho",
    jobPosition: "Área de trabalho",
    register: "CADASTRAR",
    errorInInvitation: "Erro no convite",
  },
  settings: {
    unitMeasurement: "Unidade de medida",
    success: "Sucesso!",
    yourChangesHaveSaved: "Suas alterações foram salvas.",
    changingUnitStillNotAppliedOperationInsights:
      "Trocar unidades de medida ainda não está disponivel na funcionalidade dos Eventos operacionais",
    wind: "VENTO",
    knots: "nós",
    ms: "m/s",
    mph: "mph",
    kmh: "km/h",
    current: "CORRENTE",
    wave: "ONDA",
    m: "m",
    km: "km",
    ft: "pés",
    waterLevel: "NÍVEL D'ÁGUA",
    cm: "cm",
    precipitation: "CHUVA",
    mm: "mm",
    inches: "polegadas",
    settings: "Configurações",
    selectHowYouWantToSee: "Selecione como deseja visualizar",
    visibility: "Visibilidade",
    adjustYouPreferences:
      "Ajuste suas preferências para o i4cast, ao alterar, os ajustes vão refletir imediatamente.",
    timezone: "Fuso horário",
  },
  admin: {
    changePassword: {
      passwordNotMatch: "A senha não corresponde",
      successChangedPassword: "Sucesso! Você mudou sua senha",
      currentPassword: "Senha atual",
      newPassword: "Nova Senha",
      confirmNewPassword: "Confirme a nova senha",
      updatePassword: "Atualizar senha",
    },
    myData: {
      pleaseInformPhoneNumber: "Por favor, informe seu telefone.",
      dataEditedSuccess: "Dados editados com sucesso",
      myData: "Meus dados",
      name: "Nome",
      pleaseInputYourName: "Por favor, insira seu nome!",
      middleName: "Nome do meio",
      lastName: "Sobrenome",
      pleaseInputYourLastName: "Por favor, insira seu sobrenome!",
      changePassword: "Mudar senha",
      email: "Email",
      pleaseInputYourEmail: "Por favor, insira seu e-mail!",
      selectYourJobPosition: "Selecione seu cargo",
      pleaseSelectJobPosition: "Por favor, selecione o seu cargo na lista!",
      selectYourJobArea: "Selecione seu setor de trabalho",
      pleaseSelectJobArea: "Selecione seu setor de trabalho na lista!",
      edit: "Editar",
      portuguese: "Português",
      english: "inglês",
      errorGetUserData:
        "Erro ao buscar dados do usuário. Por favor entre em contato.",
      errorUpdateUserData:
        "Erro ao atualizar dados do usuário. Por favor entre em contato",
      errorGetUserPositionData:
        "Erro ao buscar dados da posição do usuário. Por favor entre em contato",
      errorGetUserAreaData:
        "Erro ao buscar dados da área do usuário. Por favor entre em contato",
      success: "Successo",
      errorUpdateUserLanguage:
        "Erro ao atualizar idioma do usuário. Por favor entre em contato",
      error: "Erro",
      phone: "Telefone",
      pleaseEnterValidPhone: "Por favor, insira um número de telefone válido",
      updatePhoneNumber: "Atualizar número de telefone",
      enterYourNewPhone: "Digite seu novo número de telefone",
      sendVerificationCode: "Enviar código de verificação",
      updateNumber: "Atualizar número",
      verifiedNumber: "Número verificado",
      numberNotVerified: "Número não verificado",
      phoneSuccessfullyUpdated: "Sucesso! Seu número de telefone foi salvo.",
      iAgreeReceive:
        "Concordo em receber alertas via WhatsApp sobre condições de risco.",
      phoneAlreadyInUse: "Este número de celular já está em uso.",
      alreadyVerifiedNumber: "Número já verificado",
      verifyPhoneToReceiveAlerts:
        "Você criou um alerta! Para receber as notificações via WhatsApp, é necessário verificar seu número de telefone.",
    },
    userManager: {
      yourInviteSuccessfullySent:
        "Viva! Seu convite foi enviado com sucesso e um novo usuário está chegando!",
      errorWhileSendInvitation:
        "Erro ao tentar enviar o convite. Entre em contato conosco.",
      userPermissionGroupSuccessfully:
        "Grupo de permissão de usuário aplicado com sucesso",
      errorWhileEditUser:
        "Erro ao tentar editar o usuário. Por favor, entre em contato conosco.",
      userDataNotFoundOnList:
        "Dados do usuário não encontrados na lista. Por favor, entre em contato conosco.",
      userDeactivatedSuccessfully: "Usuário desativado com sucesso",
      userReactivatedSuccessfully: "Usuário reativado com sucesso",
      errorWhileDeactivateUser:
        "Erro ao tentar desativar o usuário. Entre em contato conosco.",
      errorWhileReactivateUser:
        "Erro ao tentar reativar o usuário. Entre em contato conosco.",
      userManager: "Gerenciador de usuários",
      inviteUser: "Convidar Usuário",
      inviteNewUserFromOrganization:
        "Convide um novo usuário da sua empresa para acessar ao i4cast®!",
      invite: "Convidar",
      thisIsStillNotValidEmail: "Este ainda não é um e-mail válido!",
      pleaseInputYourEmail: "Por favor, insira seu e-mail!",
      emailAlreadyHasi4cast: "O e-mail já possui uma conta i4cast",
      userGroup: "Grupo de usuários",
      admin: "Admin",
      hasPermissionManageInviteUsers:
        "Tem permissão para gerenciar e convidar novos usuários.",
      basic: "Básico",
      canAccessEditAllFeatures:
        "Pode acessar e editar todos os recursos do i4cast.",
      pleaseInput: "Insira",
      granted: "Permitido",
      denied: "Negado",
      name: "Nome",
      username: "Usuário",
      email: "Email",
      permissionGroup: "Grupo de permissão",
      accessToI4cast: "Acesso ao i4cast®",
      areYouSureWantDeactivateUser:
        "Tem certeza que deseja desativar este usuário?",
      areYouSureWantreactivateUser:
        "Tem certeza que deseja reativar este usuário?",
      yes: "Sim",
      no: "Não",
      deactivate: "Desativar",
      reactivate: "Reativar",
      ok: "Ok",
      reset: "Resetar",
      invalidUserGroup: "Grupo de usuários inválido",
      expiredInvitation: "Convite expirado",
      invitedAlreadyUsed: "Convite já utilizado",
      thisEmailAlreadyInvited: "Este e-mail já foi convidado",
      thisEmailAlreadyUse: "Esse email já está em uso",
      invitationNotFound: "Convite não encontrado",
      readOnly: "Somente leitura",
      allowVisualizeData:
        "Permite visualizar dados e informações sem a capacidade de alterá-los.",
    },
  },
  analytics: {
    waterLevel: "Nível d'água",
    weather: "Tempo",
    current: "Corrente",
    wind: "Vento",
    wave: "Onda",
    selectRegion: "Selecione uma região",
    selectStation: "Selecione uma estação",
    sensorDataNotAvailable:
      "Desculpe, o dado do sensor não esta disponível para essa estação.",
    errorGetSensorData:
      "Erro ao buscar dados do sensor. Por favor entre em contato.",
    sensorData: "Dados do sensor",
    errorToTryGetDataStationOnAnalytics:
      "Erro ao tentar obter a estação de dados no tipo de gráfico analítico medido. Entre em contato conosco.",
    sorryButNoSensorsAreAvailableforData:
      "Desculpe, mas não há sensores disponíveis para este tipo de dados.",
  },
  atmOcean: {
    clickToGoBackPastForecasts: "Clique para voltar às previsões anteriores",
    youNeedSelectStationToExport:
      "Ops! Você precisa selecionar uma estação para exportar os dados.",
    waterFlow: "Nível e Correntes",
    waveSea: "mar de ondas",
    waveSwell: "ondulação",
    selectStation: "Selecione uma estação",
    exportCsv: "Exportar .csv",
    time: "Tempo",
  },
  dynamicUKC: {
    dynamicClearanceNotAvailable:
      "Cálculos dinâmicos de folga abaixo da quilha não estão disponíveis para sua empresa. Gostaria de solicitar esta funcionalidade?",
    gotIt: "Entendi!",
    skip: "pular",
    settings: "Configurações",
    ukcRestriction: "Restrição de FAQ",
    meters: "metros",
    close: "Fechar",
    save: "Salvar",
    station: "Estação",
    travelCode: "Código de viagem",
    dynamicUkcDocking: "FAQ Dinâmica - Atracação",
    maneuverDraft: "Calado de Manobra",
    dynamicUkc: "FAQ Dinâmica",
    ukcRestrictionLower: "Restrição FAQ",
    dynamicUkcUndocking: " FAQ Dinâmica - Desatracação",
    selectShip: "Selecione um navio",
    alert: "Alerta",
    clickToBeRedirected:
      "Clique abaixo para ser redirecionado para a FAQ Dinâmica",
    gotToDynamicUkc: "Ir para FAQ Dinâmica",
  },
  forecastChart: {
    forecastChartFormStation: {
      informStationDescription: "Informe a descrição da estação.",
      failedGetVirtualStationGeolocation:
        "Falha ao obter a geolocalização da estação virtual. Entre em contato conosco.",
      youAreOutOfRegionArea: "Ops! Você está fora da área da região.",
      stationDescription: "Descrição da estação",
      save: "Salvar",
      doYouWantSaveStation: "Deseja salvar a estação?",
      saveStation: "Salvar estação",
      areYouSureWantDeleteStation:
        "Tem certeza de que deseja excluir esta estação?",
      yes: "Sim",
      no: "Não",
      requiredField: "Campo obrigatório",
      invalidLatLng: "Latitude e longitude inválidas",
      searchCoordsLatLng: "Pesquisar coordenadas (latitude e longitude)",
      cancel: "Cancelar",
      search: "Pesquisar",
      searchCoord: "Pesquisar coordenadas",
      removeStation: "Remover estação",
      unauthorizedUser:
        "Ops! Parece que você não tem permissão para deletar esta estação. Entre em contato com o administrador do sistema.",
      youOnlyHaveReadPermission: "Você só tem permissão para leitura",
    },
    forecastChartPage: {
      youAreOutOfRegionArea: "Ops! Você está fora da área de sua região.",
      thereIsAlreadyStationName: "Já existe uma estação com esse nome:",
      errorToSaveVirtualStation:
        "Erro ao salvar estação virtual. Por favor, entre em contato conosco.",
      successSationHasSaved: "Sucesso! A estação foi salva",
      errorToRemoveStation:
        "Erro ao remover a estação. Por favor, entre em contato conosco.",
      station: "Estação:",
      errorToGetDataStationMeteogramChartType:
        "Erro ao tentar obter a estação de dados no tipo de gráfico de meteograma. Por favor, entre em contato conosco.",
      errorToGetDataValidStationMeteogramChartType:
        "Erro ao tentar obter uma estação válida de dados no tipo de gráfico de meteograma. Por favor, entre em contato conosco.",
      stationWithInsight: "Estação com Evento",
      clickBlueMarkersInTheMap:
        "Clique nos marcadores azuis no mapa caso queira",
      toDisplayForecastChartWaveSpectra:
        " exibir gráficos de previsão com tipo de dados Wave Spectra ",
      letsGo: "Vamos lá",
      newEraForForecast: "Uma nova era para a previsão",
      geospatialInsight: "Evento geoespacial",
      exploreGeospatialInsights:
        "Explore eventos geoespaciais para compreender as condições climáticas em sua região. Tome decisões com uma visão completa das condições meteorológicas em áreas estratégicas para otimizar suas operações e planejamento.",
      minimizeRisks: "Minímize riscos",
      analysingPoints: "análisando pontos ao seu redor",
      customAnalysis:
        "Personalização das Análises: Personalize suas análises climáticas de acordo com os Eventos selecionados",
      newEraGeospatial: "Uma nova era geoespacial",
      inI4castPush: "no i4cast impulsiona a tomada de decisões estratégicas.",
      insightForAllStations: "Evento para todas as estações",
      chooseInsight:
        "Escolha um evento e navegue entre as estações para visualizá-lo.",
      insightType: "Tipos de Evento",
      nowToCreateAnInsight:
        "Agora, ao criar um Evento, é possível categorizá-lo como 'Permissivo' ou 'Restritivo'. Isso significa que, ao selecionar um Evento na tela de Prevísão, ele será representado de acordo com a categoria escolhida da seguinte maneira:",
      permissive: "Permissivo",
      noEvent: "Sem evento",
      warning: "Atenção",
      withEvent: "Com evento",
      restrictive: "Restritivo",
      gotIt: "Entendido",
      back: "Voltar",
      next: "Próximo",
      skip: "Pular",
      last: "Fechar",
      createAlert: "Criar alerta",
      createEvent: "Criar evento",
      sensorForecastData:
        "Esta estação não possui sensor. Exibindo dados de previsão.",
      noSensorWasFound: "Nenhum sensor foi encontrado para esta região",
    },
    forecastChartPanelHeader: {
      noData: "Evento não encontrado!",
      enterAtLeastThreeLetters: "Insira pelo menos 3 letras",
      enterYourInsight: "Digite o seu Evento aqui",
      showInsightInForecastCharts: "Exibir evento no gráfico de previsão",
      insightWithoutData: "Estações sem dados",
      theGrayIconIndicates:
        "O ícone cinza indica falta de dados para o Evento selecionado",
      thereIsNoInsightDataAvailable:
        "Não há dados de evento disponíveis para essa estação",
      noEventsForThisStation: "Não há nenhum evento previsto para essa estação",
      markAsFavorite: "Marcar como favorito para acesso rápido!",
      insightFavoriteSuccessOnSave:
        "Sucesso! Seu Evento foi marcado como favorito",
      opsErrorMarkingInsightAsFavorite:
        "Ops! Erro ao marcar evento como favorito",
      insightFavoriteSuccessOnDelete:
        "Sucesso! Seu Evento foi removido como favorito",
      opsErrorOnRemoveInsightAsFavorite:
        "Ops! Erro ao remover evento como favorito",
      removeFavorite: "Remover favorito",
      selectStation: "Oops! Selecione uma estação para visualizar o evento!",
      selectInsightToEnable:
        "Selecione um evento para ativar esta visualização.",
      loading: "Carregando",
    },
    forecastChartInsightTimeline: {
      swapToSetRanges: "Deslize para definir intervalos nos círculos externos.",
      useTheCursorToAdjustTime:
        "Use o cursor para ajustar os intervalos de tempo no círculo externo. Arraste para definir novos períodos.",
    },
    forecastChartInsightLegend: {
      realTimeForecast: "Previsão tempo real",
      forecastTimeline: "Período da Timeline",
      innerCircle: "Círculo interno",
      outerCircle: "Círculo externo",
    },
    forecastChartPanelEnvironmentalButtons: {
      weather: "Tempo",
      wave: "Ondas",
      visibility: "Visibilidade",
      waveHeight: "Altura da onda",
      waveHeightMax: "Altura máxima da onda",
      wavePeakPeriod: "Período de pico",
      waveMeanPeriod: "Período médio",
      waterFlow: "Nível e Correntes",
      stationWithInsight: "Estação com Evento",
      wind: "Vento",
      wind10m: "Vento 10m",
      wind50m: "Vento 50m",
      wind100m: "Vento 100m",
      gust10m: "Rajada 10m",
      gust50m: "Rajada 50m",
      gust100m: "Rajada 100m",
      temperature: "Temperatura",
      waveTotal: "Total",
      waveSea: "Local",
      waveSwell: "Swell",
      rain: "Chuva",
      accumulatedRain: "Chuva Acumulada",
    },
    forecastChartPanelMap: {
      searchLocationOrLatLon: "local de pesquisa ou lat, lon",
      exactLocation: "Localização exata",
      insightDataUpdate: "Marcadores geoespaciais resetados.",
      insightDataUpdateDescription:
        "Último cálculo de eventos há 15 minutos para esta região. Dados atualizados na área selecionada.",
      searchAddress: "Pesquisar endereço",
      noInsightData: "sem dados de Evento",
      sensorDataIsDelayed: "Os dados do sensor estão atrasados.",
      loading: "Carregando",
      noRadarDataAvailable: "Sem dados de radar disponível.",
    },
    forecastChartPanelMeteogram: {
      all: "max",
      dataInterval: "Intervalo de dados",
      refreshToseeNewData: "Atualize para ver os novos dados disponíveis",
      thereIsnotDataAvailable:
        "Ops! Não há dados de {{empty}} {{location}} {{empty2}} disponíveis neste local.",
      thereIsnotProbabilisticDataAvailable:
        "Ops! Não há dados probabilísticos de {{empty}} {{location}} {{empty2}} disponíveis neste local.",
      thereIsnotSensorDataAvailable:
        "Ops! Não há dados medidos de {{empty}} {{location}} {{empty2}} disponíveis neste local.",
      somethingWrong: "Ops! Algo deu errado!",
      lastUpdatedAt: "Última atualização em",
      delayedSensor: "Os dados do sensor estão atrasados",
      nextUpdateEstimatedAt: "Próxima atualização estimada em",
      aboutForecast: "Sobre a previsão",
      aboutSensor: "Sobre os sensores",
      aboutProbabilistic: "Sobre as probabilidades",
      hours: " horas",
      hour: " hora",
      min: "min",
      share: "Compartilhar previsão",
      newsOnForecast: "Novidade nas previsões",
      nowItsPossibleShare:
        "Agora é possível compartilhar as previsões com outras pessoas de forma fácil e rápida! Clicando em",
      onForecastScreen:
        "na tela de Previsões, você pode enviar suas previsões por e-mail.",
      close: "Fechar",
      gotIt: "Entendido",
      insights: "Eventos",
      select: "Selecionar",
      selectInsightFromList: "Selecione um Evento para ser exibido no gráfico",
      compareInsightsWithMeteogram: "Compare eventos junto ao meteograma!",
      selectInsight: "Selecionar Evento",
      showInsight: "Exibir Evento",
      noEventsForThisStation: "Não há nenhum evento previsto para essa estação",
      toViewTheInsightSelectALongerPeriod:
        "Nas próximas {{hours}}h não terá evento. Para visualizar o Evento selecione um período maior",
      nowYouCanVisualizeTheInsightOnMeteogram:
        "Agora você pode visualizar o seu Evento junto com o Meteograma! Uma estação com Evento está representada no mapa em verde, basta seleciona-lá, escolher o Evento que deseja visualizar e pronto! Seu Evento irá aparecer no gráfico",
      noEvent: "sem evento",
      warning: "atenção",
      withEvent: "com evento",
      insightOff: "Evento inativo",
      insightCloseToBeingActivated: "Evento próximo de ser ativado",
      insightOn: "Evento ativo",
      confidence50: "50% de confiança",
      confidence80: "80% de confiança",
      median: "Mediana",
      windSpeed10m: "Velocidade do vento 10m",
      windSpeed50m: "Velocidade do vento 50m",
      significantWaveHeight: "Altura significativa da onda",
      closeChart: "Fechar gráfico",
      unavailable: "Indisponível",
      deterministic: "Previsão",
      probabilistic: "Probabilidade",
      cloud_base_height: "Altura da base da núvem",
      windsGusts: "Ventos/Rajadas",
      slp: "Pressão ao nível do mar (Slp)",
      preciptation: "Chuva",
      precipitationAccumulated: "Chuva Acumulada",
      waveHeights: "Alturas de ondas",
      peakPeriod: "Período de pico",
      wavePower: "Potência de onda",
      clickOnMapToOpen: "Clique no mapa para abrir novamente o gráfico.",
      itAppearsThatYourRegion:
        "Essa região não possui dados de probabilidade para a variável selecionada",
      contactOurTeamToEnsure:
        "Entre em contato conosco para trazer essa funcionalidade para você!✨",
      thisRegionDoesNotHavePrecip:
        "Essa região não possui dados sobre a precipitação mínima, máxima e a probabilidade de chuva.",
      thisRegionDoesNotHaveVisibility:
        "Essa região não possui dados de visibilidade mínima, máxima e a probabilidade de visibilidade",
      getInTouch: "Entre em contato",
      forecastChart: "Gráfico de previsão",
      probabilisticChart: "Gráfico de probabilidade",
      sensorChart: "Gráfico de dados medidos",
      metOceanForecastReport: "Relatório de previsão MetOcean",
      reportTable: "Previsão Tabular",
      probability: "Probabilidade",
      reflectivity: "Refletividade (dBZ)",
      vweak: "M.FRACO",
      weak: "FRACO",
      moderate: "MODERADO",
      strong: "FORTE",
      vstrong: "M.FORTE",
      precipitationPotential: "Potencial de Precipitação (mm/h)",
      radarDataUnavailable:
        "Dados de radar indisponíveis. Por favor, tente novamente mais tarde.",
      waterLevel: "Nível d'água",
      news: "Novidade! ✨",
    },
    forecastTable: {
      title: "Previsão Tabular",
      tableColumnStation: "Estação",
      tableTresholdTooltipLessThan: "Limite menor que",
      tableTresholdTooltipGreaterThan: "Limite maior que",
      thresholdTooltip: "Digite aqui o limite desta variável.",
      dates: "Data/Hora",
      getDataError: "Ocorreu um erro inesperado, por favor, tente novamente!",
      selectStationLabel: "Estação",
      selectStationError:
        "Ocorreu um erro inesperado, por favor tente novamente!",
      loadingForecastTableData: "Carregando Previsão Tabular...",
      forecastTablePleaseWaitAMoment:
        "Aguarde um momento, isso pode levar alguns segundos! ",
      manageColumnsModalCancel: "Cancelar",
      manageColumnsModalSave: "Salvar",
      hideColumn: "Ocultar coluna",
      manageColumns: "Gerenciar Colunas",
      thresholdTitle: "Limite",
      manageColumnTitle: "Gerenciar Colunas",
      environmentalVariableEnum: {
        weather: "Tempo",
        weather_temperature: "Temperatura",
        wave: "Ondas",
        wave_sea: "Onda de vento",
        wave_swell: "Onda de swell",
        water_flow: "Nível e Correntes",
        wind_vel: "Vento 10m",
        wind_dir: "Dir. 10m",
        slp: "Slp",
        gust: "Rajada 10m",
        water_level: "Nível d'água",
        current_vel: "Corrente vel",
        current_dir: "Corrente dir",
        wave_height: "Altura sig.",
        wave_dir: "Dir.",
        peak_period: "Período de pico",
        mean_period: "Período médio",
        wave_height_sea: "Altura",
        wave_dir_sea: "Dir.",
        peak_period_sea: "Período de pico",
        wave_height_swell: "Altura",
        wave_dir_swell: "Dir.",
        peak_period_swell: "Período de pico",
        precip: "Chuva",
        wind_vel_80m: "Vento 50m",
        wind_dir_80m: "Dir. 50m",
        gust_80m: "Rajada 50m",
        wind_vel_100m: "Vento 100m",
        wind_dir_100m: "Dir. 100m",
        gust_100m: "Rajada 100m",
        wave_height_max: "Altura máx",
        visibility: "Visibilidade",
        temp_air: "Temp. do ar",
        temp_water: "Temp. da água",
        dew_point: "Ponto de orvalho",
        wave_power: "Potência",
        mean_period_swell: "Período médio",
        mean_period_sea: "Período médio",
        rel_humidity: "Umidade relativa a 2m",
        precip_min_20km: "Chuva mínima e máxima",
        precip_probability: "Probabilidade de chuva",
        precipitation: "Chuva",
        precip_accumulated: "Chuva acumulada",
        water_properties: "Propriedades da água",
        cloud_base_height: "Altura base das nuvens",
        precip_accum_1h: "Chuva acum. 1h",
        precip_accum_3h: "Chuva acum. 3h",
        precip_accum_6h: "Chuva acum. 6h",
        precip_accum_12h: "Chuva acum. 12h",
        precip_accum_24h: "Chuva acum. 24h",
        precip_accum_48h: "Chuva acum. 48h",
        precip_accum_72h: "Chuva acum. 72h",
        precip_accum_96h: "Chuva acum. 96h",
        precip_accum_120h: "Chuva acum. 120h",
        landslide_probability_risk: "Índice de acumulado de chuva",
        icing_probability: "Probabilidade de gelo",
      },
    },
    forecastChartPanelMeteogramEnvironmentalButtons: {
      wave: "Onda total",
      waveSea: "Onda local",
      waveSwell: "Onda swell",
    },
    forecastChartPanelMeteogramWeatherButtons: {
      weather: "Vento",
      weatherTemperature: "Temperatura",
    },
    forecastChartPastForecast: {
      noPastDataAvailable: "Não há dados anteriores disponíveis",
      pastForecast: "Previsões anteriores",
      pastMeasurement: "Medições anteriores",
      time: "Horário:",
    },
    forecastChartRequestSpectraStationButton: {
      yourRequestSuccessfullySent: "Sua solicitação foi enviada com sucesso!",
      requestSeaSwellAtThisLocation:
        "Solicite ondas de mar e swell neste local",
    },
    forecastChartMeteogramStore: {
      errorTryGetDataChartMeteogram:
        "Erro ao buscar dados do meteograma. Por favor entre em contato.",
      noUpcomingEvents: "NENHUM EVENTO PRÓXIMO",
    },
    forecastChartProbabilisticStore: {
      errorTryGetData: "Erro ao buscar dados. Por favor entre em contato.",
    },
    metOceanReport: {
      metOceanForecastReport: "Relatório de previsão MetOcean",
      generate: "Gerar",
      selectAtLeastOneVariable:
        "Selecione pelo menos uma variável e uma estação",
      selectAtLeastOneStation:
        "Selecione uma estação para a variável selecionada",
      selectTheVariablesAndStations:
        "Selecione as variáveis e estações que deseja visualizar",
      weather: "Tempo",
      wave: "Onda",
      waterFlow: "Nível e Correntes",
      waterProperties: "Propriedades da água",
      cancel: "Cancelar",
      generatingForecast: "Gerando relatório de previsão...",
      pleaseWaitAMoment:
        "Aguarde um momento, isso pode levar alguns segundos! ⏳",
      weWereUnableToOpen:
        "Não conseguimos abrir o PDF porque o navegador bloqueou pop-ups. Habilite pop-ups nas configurações do seu navegador e tente novamente.",
    },
  },
  portOfCallStore: {
    errorToGetOperationWindowData:
      "Erro ao obter os dados da janela de operação. Por favor, entre em contato conosco.",
    errorToGetDockingDynamicUkcData:
      "Erro ao obter dados UKC dinâmicos de ancoragem. Por favor, entre em contato conosco.",
  },
  unitMeasurementStore: {
    errorToAddUnitMeasurement:
      "Erro ao adicionar unidade de medida. Por favor, entre em contato conosco",
  },
  whatIsNew: {
    whatIsNew: "O que há de novo!",
    markAllAsRead: "Marcar tudo como lido.",
  },
  share: {
    shareForecast: "Compartilhar previsão",
    period: "Período",
    all: "max",
    environmentalVariables: "Variáveis ​​ambientais",
    weather: "Tempo",
    selectStation: "Selecione a estação",
    wave: "Onda",
    waterFlow: "Nível e Correntes",
    recipients: "Destinatários",
    sendMeThisEmail: "Envie-me este e-mail",
    externalRecipients: "Destinatários externos",
    inviteToI4cast: "Convidar para i4cast",
    message: "Mensagem (opcional)",
    cancel: "Cancelar",
    submt: "Enviar",
    inThisFieldItsPossibleShareByEmail:
      "Compartilhe por e-mail com pessoas que ainda não fazem parte do i4cast.",
    separateEmailsWithComma:
      "Separe os e-mails com vírgula. Ex: john@i4sea.com, new@i4sea.com",
    selectAtLeastOneEnvironmentalVariable:
      "Selecione pelo menos uma variável ambiental e uma estação.",
    emailsBelowAreNotValid: "Os emails abaixo não são válidos.",
    selectAtLeastOneVariable: "Selecione pelo menos uma variável e uma estação",
    youMustSelectAtLeast:
      "É preciso selecionar pelo menos um destinatário interno ou externo",
    selectAtLeastOneStation:
      "Selecione uma estação para a variável selecionada",
    successEmailHasSend: "Sucesso! Seu email foi enviado",
    errorSendingEmail: "Erro ao enviar o email",
    helloIWouldLikeToShare:
      "Olá, gostaria de compartilhar com você os dados de previsão do i4cast. Anexo a este e-mail.",
    thereIsnotDataInThisStation:
      "Não há dados do tipo {{environmentalTypeTranslated}} na estação: {{stationName}}. Por favor, selecione outra estação",
    water_flow: "Nível e Correntes",
    shareReportByEmail:
      "Compartilhe um relatório da previsão via email sem sair do i4cast!",
    forGuestUsersMustUseAnEmailDomain:
      "Convide novos usuários para o i4cast. Apenas usuários com o domínio da sua empresa poderão ser convidados (Ex.: joao@i4sea.com). Caso precise convidar outros usuários, entre em contato conosco.",
  },
  dualList: {
    selectAll: "Selecionar todos",
    notSelected: "Não selecionados",
    deselectAll: "Desmarcar todos",
    selected: "Selecionados",
    search: "Pesquisar",
  },
  occurrence: {
    reportOccurrence: "Reportar ocorrência",
    reportOccurrenceDetail:
      "Reporte uma ocorrência que gerou impacto nas suas operações. A partir disso, nosso sistema poderá identificar e notificar previsões semelhantes no futuro.",
    cancel: "Cancelar",
    save: "Salvar",
    selectStation: "Selecione a estação mais próxima do local da ocorrência",
    selectEnvironmentalVariables:
      "Selecione as variáveis ambientais que podem ter impactado nesta ocorrência",
    ocurrencePeriod: "Período da ocorrência",
    singleDate: "Data única",
    period: "Início e fim",
    description: "Descrição da ocorrência",
    strongWinds: "Ventos fortes interromperam a operação de conteiner",
    latitude: "Latitude",
    longitude: "Longitude",
    forecastHelp: "A previsão do i4cast acertou?",
    wantToBeNotified:
      "Desejo ser avisado quando condições semelhantes forem previstas",
    yes: "Sim",
    no: "Não",
    wind: "Vento",
    current: "Corrente",
    wave: "Onda",
    rain: "Chuva",
    fog: "Neblina",
    waterLevel: "Nível d'água",
    temperature: "Temperatura",
    occurrences: "Ocorrências",
    newOccurrence: "Reportar ocorrência",
    search: "Pesquisar",
    descriptionRequired: "Descrição é obrigatória!",
    stationRequired: "Selecione uma estação!",
    latitudeRequired: "Latitude é obrigatória!",
    longitudeRequired: "Longitude é obrigatória!",
    selectAtleastOneVariable:
      "Selecione ao menos uma variável ambiental que pode ter impactado na ocorrência.",
    successReport: "Ocorrência reportada com sucesso!",
    errorReport: "Erro ao reportar ocorrência!",
    deleteOccurrence: "Excluir Ocorrência",
    delete: "Excluir",
    areYouSureWantDelete:
      "Você tem certeza que deseja excluir essa Ocorrência?",
    errorEditOccurrence: "Erro ao editar ocorrência!",
    successEditOccurrence: "Sucesso! Sua ocorrência foi salva",
    errorYouNeedToSelectAnOccurrence:
      "Erro! Você precisa selecionar uma ocorrência",
    youDonyHaveAOccurrenceYet:
      "Você ainda não possui uma ocorrência. Clique no botão para reportar uma ocorrência",
    addOccurrence: "Reportar Ocorrência",
    time: "Hora:",
    selectDate: "Selecione uma data",
    dateRequired: "Data é obrigatório!",
    exactLocation:
      "Deseja informar a localização exata da ocorrência? (opcional)",
    selectOption: "Selecione uma opção!",
    startDateMustBeLessThanEndDate:
      "A data inicial deve ser menor do que a data final",
    windInfo:
      "Ao selecionar esta opção, o i4cast utilizará dados da velocidade do vento, direção e rajada para identificar eventos semelhantes.",
    waveInfo:
      "Ao selecionar esta opção, o i4cast utilizará dados da altura significativa das ondas, direção e período de pico para identificar eventos semelhantes.",
    rainInfo:
      "Ao selecionar esta opção, o i4cast utilizará dados de precipitação para identificar eventos semelhantes.",
    fogInfo:
      "Ao selecionar esta opção, o i4cast utilizará dados de visibilidade para identificar eventos semelhantes.",
    temperatureInfo:
      "Ao selecionar esta opção, o i4cast utilizará dados de temperatura do ar para identificar eventos semelhantes.",
    waterLevelInfo:
      "Ao selecionar esta opção, o i4cast utilizará dados de nível d'água para identificar eventos semelhantes.",
    currentInfo:
      "Ao selecionar esta opção, o i4cast utilizará dados de velocidade e direção das correntes para identificar eventos semelhantes.",
    forecastCorrect:
      "Na sua opinião, a previsão do i4cast te ajudou a identificar essa ocorrência?",
    occurrencesAreEventsThatImpactYourOperation:
      "Ocorrências são eventos que podem causar impacto nas suas operações. Reporte ocorrências para que o i4cast se torne mais inteligente. Identificaremos previsões similares no futuro e você será notificado.",
    startHourIsRequired: "A hora de início é obrigatória",
    endHourIsRequired: "A hora final é obrigatória",
    importOccurrence: "Importar ocorrência",
    selectFileToImport:
      "Selecione um arquivo para importar (pdf, excel, word e txt):",
    import: "Importar",
    successOnImport: "Sucesso! Recebemos seu arquivo com as ocorrências.",
    youNeedToChooseFile: "Selecione um arquivo para importar!",
    weAreProcessingTheWorkSheet:
      "Estamos processando a planilha com as ocorrências. Em breve, iremos notificar você assim que estiverem concluídas.",
    theSelectedFileExceedsMaxium:
      "O arquivo selecionado excede o tamanho máximo permitido de 5MB.",
    importYourOccurrencesSpreadSheet:
      "Já tem algum documento com registro de ocorrências climáticas? Importe aqui e nós cadastramos pra você!",
    successfullyUploaded: "Upload feito com Sucesso!",
    yourFileWithOccurrenceWasSent:
      "Seu arquivo com ocorrências foi enviado com sucesso e assim que estiverem cadastradas no i4cast, você será notificado por e-mail!",
    iGotIt: "Entendi!",
    selectAFile: "Selecionar arquivo",
    selectedFile: "Arquivo selecionado:",
    noFileSelected: "Nenhum arquivo selecionado",
    newsInOccurrence: "Novidade nas ocorrências",
    nowItsPossibleImportSpreadSheet:
      "Agora é possível importar uma planilha ou documento com as suas ocorrências, facilitando o cadastro e tornando o i4cast mais inteligente!",
    try: "Experimentar",
  },
  feedback: {
    successSendFeedback: "Sucesso! Seu feedback foi enviado",
    errorSendFeedback: "Erro ao enviar feedback",
    thisFieldIsRequired: "Esse campo é obrigatório",
    send: "Enviar",
    yes: "Sim",
    no: "Não",
    typeYourAnswerHere: "Digite aqui a sua resposta",
  },
  manageStation: {
    manageStation: "Gestão de estações",
    configureWhichStationViewHistoricalData:
      "Configure quais estações você deseja visualizar dados históricos",
    name: "Nome",
    region: "Região",
    latLon: "Localização (lat, lon)",
    historicalData: "Dados históricos",
    search: "Pesquisar",
    station: "Estação",
    page: "Página",
    of: "de",
    filterBy: "Filtrar por",
    forecastDataType: "Tipo de dados de previsão",
    weather: "Tempo",
    wave: "Onda",
    waveSpectra: "Onda Espectral",
    waveSea: "Onda local",
    waveSwell: "Onda swell",
    waterFlow: "Nível e Correntes",
    dataHistory: "Histórico de dados",
    environmentalType: "Tipo ambiental",
    selectAtLeastOneEnvironmentalType:
      "Selecione pelo menos um tipo de variável ambiental",
    save: "Salvar",
    successEditStation: "Sucesso! Sua estação foi salva",
    errorEditStation: "Erro ao editar estação!",
    errorNoEnvironmentalDataAtStation:
      "Existem tipos de variáveis ambientais não disponíveis para essa estação!",
    enterAtLeastThreeLetters: "Digite ao menos 3 letras",
    notFound: "Não encontrado",
    clean: "Limpar",
  },
  analyticsReporting: {
    period: "Período de análise",
    environmentalType: "Tipo de evento",
    weather: "Tempo",
    location: "Localização",
    environmentalVariable: "Variável ambiental",
    windSpeed: "Velocidade do vento",
    direction: "Direção",
    minimum: "Mínimo",
    maximum: "Máximo",
    knots: "nós",
    forecastAdvancePeriod: "Período de cada previsão",
    before: "antes",
    generateAnalysis: "Gerar análise",
    hoursEarned: "Horas ganhas",
    hoursGainIsHowMuchMoreAccuratei4castWas:
      "Horas ganhas representa a quantidade de horas que o i4cast foi mais assertivo em comparação ao modelo global",
    moreThanGlobal: "mais assertivo que o modelo global",
    eventsCaptured: "Eventos capturados",
    fillINTheFieldsBelowViewData:
      "Preencha os campos ao lado para visualizar os dados",
    eventsCapturedRepresentTheQuantityOfEvents:
      "Eventos capturados representa a quantidade de eventos que o i4cast capturou a mais do que o modelo global",
    degrees: "graus",
    region: "Região",
    selectRegion: "Selecione uma região",
    selectLocation: "Selecione um localização",
    selectEvent: "Selecione um evento",
    isGreaterOrEqual: "Maior ou igual",
    isLessOrEqual: "Menor ou igual",
    startDate: "Data inicial",
    endDate: "Data final",
    requiredField: "Campo obrigatório",
    isGreaterOrEqualThan: "Maior ou igual a",
    isLessOrEqualThan: "Menor ou igual a",
    between: "entre",
    to: "a",
    globalModel: "Modelo Global",
    sensor: "Observado",
    numberOfEvents: "Qtd. de eventos",
    events: "Eventos",
    comparisonOfi4castForecastPerformance:
      "Comparação da performance da previsão do i4cast com a previsão global.",
    fillAtLeastOneField: "Preencha ao menos um dos campos",
    generatingAnalysis: "gerando análise...",
    moreAssertiveForecastHours:
      "de previsão mais assertiva do que o modelo global",
    weAreGeneratingAnalysis:
      "Estamos gerando a sua análise, isso poderá demorar alguns segundos.",
    weDoNotHaveDataAvailable:
      "Não temos dados disponíveis para o filtro selecionado. Insira novas informações para tentar novamente.",
    timeCalculation: "Cálculo de tempo",
    timeCalculationIsAPercentageOfTime:
      "Cálculo de tempo representa a porcentagem de tempo em que a condição filtrada esteve ativa na sua região",
    ofTheTimeWithWinds: "do tempo com ventos de",
    january: "Janeiro",
    february: "Fevereiro",
    march: "Março",
    april: "Abril",
    may: "Maio",
    june: "Junho",
    july: "Julho",
    august: "Agosto",
    september: "Setembro",
    october: "Outubro",
    november: "Novembro",
    december: "Dezembro",
    mostFrequently: "Mais frequente em",
    errorGeneratingAnalytics: "Erro ao gerar análise",
    theMaximumValueMustBeGreater:
      "O valor máximo deve ser maior ou igual do que o valor mínimo",
    ofTheTimeWithWindsGreaterOrEqual: "do período com vento maior ou igual",
    ofTheTimeWithWindsLessOrEqual: "do período com vento menor ou igual",
    someMonthsMayNotBeDisplayed:
      "Alguns meses podem não ser exibidos no gráfico devido à insuficiência de dados para análise de desempenho.",
    monthlyAverageWindSpeed: "Média mensal da velocidade de ventos",
    windDirection: "Direção do vento",
    average: "Média",
    standardDeviation: "Desvio padrão",
    eventFrequency: "Frequência do evento",
    first: "Primeiras",
  },
  eventHistory: {
    selectStationAndDefinePeriod:
      "Selecione uma estação e data inicial para visualizar uma análise comparativa da previsão no período de 5 dias.",
    eventHistory: "Histórico de eventos",
    selectStation: "Selecione uma estação",
    startDate: "Data inicial",
    endDate: "Data final",
    weather: "Tempo",
    wave: "Onda",
    waterFlow: "Nível e Correntes",
    waterLevel: "Nível d'água",
    current: "Corrente",
    sensor: "Sensor",
    global: "Modelo global",
    noGlobalModelDataFound:
      "Nenhum dado do modelo global foi encontrado para o filtro selecionado",
    noSensorDataFound:
      "Nenhum dado do sensor foi encontrado para o filtro selecionado",
    noi4castDataFound:
      "Nenhum dado do i4cast foi encontrado para o filtro selecionado",
    selectStationToViewData: "Selecione uma estação para visualizar os dados",
    environmentalVariable: "Variável ambiental",
  },
  eventAnalysis: {
    eventAnalysis: "Análise de eventos",
    occurrence: "Ocorrência",
    period: "Período",
    location: "Localização",
    weather: "Tempo",
    wave: "Onda",
    waterFlow: "Nível e Correntes",
    wind: "Vento",
    gust: "Rajada",
    rain: "Chuva",
    minimumValue: "Mínimo de",
    averageValue: "Média de",
    maxValue: "Máxima de",
    accumulatedValue: "Acúmulo",
    peakValue: "Pico às",
    averageWindGust: "Média de Vento | Rajada",
    maxWindGust: "Máximo de Vento | Rajada",
    averageWavePeriod: "Média de Altura | Período",
    maxWavePeriod: "Máximo de Altura | Período",
    minWaterFlowCurrent: "Mínimo da Corrente",
    maxWaterFlowCurrent: "Máximo da Corrente",
    timeSeries: "Série temporal",
    theChartBelowShows:
      "O gráfico abaixo representa uma série temporal dos dados brutos do período da ocorrência.",
    significantWaveHeight: "Altura significativa da onda",
    wavePeakPeriod: "Período de pico da onda",
    waterLevel: "Nível d’água",
    current: "Corrente",
    selectOccurrence: "Selecione uma ocorrência",
    selectAnOccurrenceToBegin:
      "Selecione uma ocorrência para começar a sua análise",
    knots: "nós",
    latitude: "latitude",
    longitude: "longitude",
    noi4castDataFound:
      "Nenhum dado do i4cast foi encontrado para a ocorrência selecionada",
  },
  environmentalVariableStore: {
    windSpeed: "Vento - Velocidade a 10m",
    windDirection: "Vento - Direção a 10m",
    windGusts: "Vento - Rajada a 10m",
    waterLevel: "Nível d'água",
    currentVelocity: "Corrente - Velocidade",
    currentDirection: "Corrente - Direção",
    waveHeight: "Onda - Altura Significativa",
    waveDirection: "Onda - Direção do Pico",
    peakPeriod: "Onda - Período de Pico",
    meanPeriod: "Onda - Período Médio",
    seaWaveHeight: "Onda - Altura Significativa local",
    seaWaveDirection: "Onda - Direção do Pico local",
    seaPeakPeriod: "Onda - Período de Pico local",
    swellWaveHeight: "Onda - Altura Significativa de Swell",
    swellWaveDirection: "Onda - Direção do Pico de Swell",
    swellPeakPeriod: "Onda - Período de Pico de Swell",
    precipitation: "Precipitação",
    windSpeedAt80m: "Vento - Velocidade a 50m",
    windDirectionAt80m: "Vento - Direção a 50m",
    windGustsAt80m: "Vento - Rajada a 50m",
    windSpeedAt100m: "Vento - Velocidade a 100m",
    windDirectionAt100m: "Vento - Direção a 100m",
    windGustsAt100m: "Vento - Rajada a 100m",
    maximumWaveHeight: "Onda - Altura Máxima",
    visibility: "Visibilidade",
    airTemperature: "Temperatura do Ar",
    dewPoint: "Ponto de Orvalho",
  },
  environmentalVariableEnum: {
    weather: "Tempo",
    weather_temperature: "Temperatura",
    wave: "Ondas",
    wave_sea: "Onda de vento",
    wave_swell: "Onda de swell",
    water_flow: "Nível e Correntes",
    wind_vel: "Vento 10m",
    wind_dir: "Direção 10m",
    slp: "Slp",
    gust: "Rajada 10m",
    water_level: "Nível d'água",
    current_vel: "Corrente vel",
    current_dir: "Corrente dir",
    wave_height: "Onda - altura significativa",
    wave_dir: "Onda - direção de pico",
    peak_period: "Onda - período de pico",
    mean_period: "Onda - período médio",
    wave_height_sea: "Onda de vento - altura",
    wave_dir_sea: "Onda de vento - direção período de pico",
    peak_period_sea: "Onda de vento - período de pico",
    wave_height_swell: "Onda swell - altura",
    wave_dir_swell: "Onda swell - direção de pico",
    peak_period_swell: "Onda swell - período de pico",
    precip: "Chuva",
    wind_vel_80m: "Vento 50m",
    wind_dir_80m: "Direção 50m",
    gust_80m: "Rajada 50m",
    wind_vel_100m: "Vento 100m",
    wind_dir_100m: "Direção 100m",
    gust_100m: "Rajada 100m",
    wave_height_max: "Onda - altura máx",
    visibility: "Visibilidade",
    probability: "Probabilidade (%)",
    visibility_maximum_20km: "Visibilidade max",
    visibility_minimum_20km: "Visibilidade mínima e máxima",
    visibility_probability_1000m: "Prob. Visibilidade menor que 1km (%)",
    visibility_probability_1500m: "Prob. Visibilidade menor que 1.5km (%)",
    visibility_probability_2000m: "Prob. Visibilidade menor que 2km (%)",
    temp_air: "Temperatura do ar",
    temp_water: "Temperatura da água",
    dew_point: "Ponto de orvalho",
    wave_power: "Potência",
    mean_period_swell: "Onda swell - período médio",
    mean_period_sea: "Onda de vento - período médio",
    rel_humidity: "Umidade relativa a 2m",
    precip_min_20km: "Chuva mínima e máxima",
    precip_probability: "Probabilidade de chuva",
    precipitation: "Chuva",
    precip_accumulated: "Chuva acumulada",
    precip_accum_1h: "Chuva acum. 1h",
    precip_accum_3h: "Chuva acum. 3h",
    precip_accum_6h: "Chuva acum. 6h",
    precip_accum_12h: "Chuva acum. 12h",
    precip_accum_24h: "Chuva acum. 24h",
    precip_accum_48h: "Chuva acum. 48h",
    precip_accum_72h: "Chuva acum. 72h",
    precip_accum_96h: "Chuva acum. 96h",
    precip_accum_120h: "Chuva acum. 120h",
    landslide_probability_risk: "Índice de acumulado de chuva",
    icing_probability: "Probabilidade de gelo",
  },
  utils: {
    now: "Agora mesmo",
    minAgo: "Há {{minutes}}min",
    oneHourAgo: "Há 1h",
    hoursAgo: "Há {{hours}}h",
    oneDayAgo: "Há 1 dia",
    daysAgo: "Há {{days}} dias",
    longTimeAgo: "Há muito tempo",
  },
  riverForecastChart: {
    extremeHigh: "Extremamente alto",
    veryHigh: "Muito alto",
    high: "Alto",
    mostLikely: "Cenário base",
    low: "Baixo",
    veryLow: "Muito baixo",
    extremeLow: "Extremamente baixo",
    sensor: "Sensor",
  },
  "404": {
    oopsPageNotFound: "Oops, página não encontrada",
    goToLogin: "Ir para login",
  },
  "500": {
    oopsAnErrorOccurred: "Oops, ocorreu um erro inesperado",
    tryAgain: "Tente novamente",
  },
  operationServices: {
    serviceRemovedSuccess: "Serviço removido com sucesso!",
    removalFailedContactUs: "A remoção falhou. Contate-nos",
    serviceUpdatedSucess: "Serviço atualizado com sucesso!",
    serviceCreatedSucess: "Serviço criado com sucesso!",
    name: "Nome",
    description: "Descrição",
    recurrence: "Recorrência",
    deleteService: "Excluir Serviço",
    areYouSureWantDeleteThisService:
      "Tem certeza de que deseja excluir este serviço?",
    delete: "Deletar",
    cancel: "Cancelar",
    loading: "Carregando",
    noData: "Nenhum dado disponível",
    serviceEdit: "Edição de Serviço",
    serviceCreate: "Criação de Serviço",
    serviceName: "Nome do serviço",
    serviceCost: "Custo do serviço",
    shipMaintance: "Manutenção do navio",
    moneyValue: "10.000,00",
    routineMaintance: "Manutenção de rotina na parte da manhã",
    repeatEvery: "Repetir a cada",
    weeks: "semanas",
    repeat: "Repetir",
    start: "Início",
    selectTime: "Selecionar data",
    end: "Fim",
    newShift: "Novo turno",
    startIn: "Inicia-se em",
    advanceHiring: "Antecedência para contratação",
    hours: "horas",
    editService: "Editar serviço",
    createService: "Criar serviço",
    services: "Serviços",
    selectDate: "Selecione uma data",
    nameIsRequired: "Nome é obrigatório",
    startTimeMustBeBeforeEndTime:
      "O horário de início deve ser antes do horário de término!",
    startDateRequired: "A data de início é obrigatória!",
    endDateRequired: "A data de término é obrigatória!",
    seleactAtLeastOneDay: "Selecione pelo menos um dia",
    startTimeRequired: "A hora de início é obrigatória!",
    endTimeRequired: "O horário de término é obrigatório!",
    doestHappenAgain: "Não se repete",
    mondayFriday: "Segunda a sexta",
    weekly: "Semanal",
    custom: "Personalizado",
    multipleShiftsDetected:
      "Há turnos repetidos com as mesmas datas e horários.",
    sunday: "D",
    monday: "S",
    tuesday: "T",
    wednesday: "Q",
    thursday: "Q",
    friday: "S",
    saturday: "S",
    currency: "Moeda",
    whatHappensWhenRegistering: "O que acontece ao cadastrar um serviço?",
    yourServiceAndShiftsWill:
      "Seu serviço e seus turnos aparecerão no gráfico de Gantt, permitindo que você visualize melhor a programação e acompanhe os eventos de previsão para otimizar sua operação.",
    visualizeYourOperations:
      "Visualize suas operações com precisão! Cadastre um serviço e acompanhe as condições do mar e do tempo.",
  },
  time: {
    minutesAgo: "{{minutes}}m atrás",
    inMinutes: "em {{minutes}}m",
    hoursAgo: "{{hours}}h atrás",
    inHours: "em {{hours}}h",
    hoursMinutesAgo: "{{hours}}h {{minutes}}m atrás",
    inHoursMinutes: "em {{hours}}h {{minutes}}m",
  },
  radarLegend: {
    showRainRdar: "Exibir radar de chuva",
    new: "Novo",
    nowcast: "Previsão",
    oneHourNowcast: "até 1h de previsão",
    light: "Fraco",
    moderate: "Moderado",
    heavy: "Forte",
    rain: "Chuva",
    snow: "Neve",
    precipitation: "Precipitação",
    error: {
      title: "Erro no Radar",
      unavailable: "Dados de radar temporariamente indisponíveis",
      noData: "Nenhum dado de radar disponível",
      connectionLost: "Conexão perdida",
    },
  },
  layer: {
    selectLayer: "Camadas",
    weather: "Tempo",
    noLayer: "Sem camada",
    wind: "Vento 10m",
    gust: "Rajada 10m",
    waves: "Ondas",
    airTemp: "Temp. do ar",
    visibility: "Visibilidade",
    rain: "Chuva",
    cloudCover: "Cobertura de nuvens",
    radars: "Radares",
    weatherRadar: "Radar meteorológico",
    layers: "Camadas",
    airPressure: "Pressão",
    tooltipRemoveLayer: "Remover camada",
    nowcast: "Previsão",
    waveHeight: "Altura significativa da onda",
    waveHeightMax: "Altura máxima da onda",
    wavePower: "Potência de onda",
    comingSoon: "Disponível em breve!",
    noWaveDataRegion:
      "Sem dados de ondas para sua região. Entre em contato para liberar.",
    noWeatherDataRegion:
      "Sem dados de weather para sua região. Entre em contato para liberar.",
    removeLayer: "Remover camada",
    maplayerDisclaimer:
      "Os gráficos de previsão em pontos específicos podem diferir dos mapas devido a atualizações mais frequentes e aprimoradas por Machine Learning.",
    startUpLayer: "Camada inicial",
    typeLayer: "Digite uma camada aqui...",
    initialLayer: "Camada exibida ao iniciar o mapa",
    noLayerDataWasFound:
      "Erro ao carregar os dados de camada. Contate o suporte se o problema persistir.",
  },
  cities: {
    utc: "UTC (Coordenada Universal)",
    gmt: "GMT (Horário de Greenwich)",

    saoPaulo: "São Paulo",
    recife: "Recife",
    bahia: "Bahia",
    buenosAires: "Buenos Aires",
    santiago: "Santiago",
    bogota: "Bogotá",
    lima: "Lima",
    mexicoCity: "Cidade do México",

    newYork: "Nova York",
    chicago: "Chicago",
    denver: "Denver",
    losAngeles: "Los Angeles",
    toronto: "Toronto",
    vancouver: "Vancouver",

    london: "Londres",
    lisbon: "Lisboa",
    paris: "Paris",
    berlin: "Berlim",
    madrid: "Madri",
    rome: "Roma",
    stockholm: "Estocolmo",
    copenhagen: "Copenhague",
    amsterdam: "Amsterdã",
    athens: "Atenas",

    tokyo: "Tóquio",
    shanghai: "Pequim",
    seoul: "Seul",
    bangkok: "Bangkok",
    mumbai: "Mumbai",
    dubai: "Dubai",

    sydney: "Sydney",
    auckland: "Auckland",
  },
  news: {
    news: "💡Novidade - Eventos operacionais",
    title: "Nova jornada simplificada de evento",
    paragraph1:
      "Repensamos a forma de criar eventos, agora você começa definindo o que quer monitorar, sem precisar decidir tudo de uma vez.",
    paragraph2Part1: "Assim,",
    paragraph2Bold1:
      "você define primeiro o que acompanhar e ajusta o uso depois,",
    paragraph2Part2: "com mais clareza e menos esforço, conforme necessidade.",
    paragraph3Part1: "Como parte dessa evolução,",
    paragraph3Bold: "Insight passa a se chamar Evento",
    paragraph3Part2: ", refletindo essa nova jornada simplificada.",
    exploreEvents: "Explorar Eventos",
    gotIt: "Entendi",
  },
  userPhoneEmailVerify: {
    iAgreeReceive:
      "Concordo em receber alertas via WhatsApp sobre condições de risco.",
    updateYourContact: "Atualize seus dados de contato no i4cast",
    keepAlwaysUpdated:
      "Esteja sempre um passo à frente! Receba os alertas de risco no WhatsApp.",
    typeEmail: "Digite seu e-mail",
    invalidEmail: "E-mail inválido",
    email: "E-mail",
    cellPhone: "Celular",
    confirm: "Confirmar",
    weSentATextToYourPhone: "Enviamos um código por SMS para o número:",
    invalidCode: "Código inválido",
    resentCode: "Reenviar código",
    back: "Voltar",
    confirmCode: "Confirmar código",
    maximumAttempts:
      "Máximo de tentativas excedido. Por favor, tente novamente em 10 minutos.",
    successYouPhone: "Sucesso! Seu e-mail e número de telefone foram salvos.",
    emailAlreadyInUse: "Este email já está em uso.",
    phoneAlreadyInUse: "Este número de celular já está em uso.",
  },
  locations: {
    createLocation: "Criar Localidade",
    editLocation: "Editar Localidade",
    area: "Área",
    locations: "Localidades",
    description:
      "Crie e edite localidades cadastradas por você ou sua empresa.",
    name: "Nome",
    coordinateType: "Tipo de Coordenada",
    coordinatesType: "Tipo de Coordenadas",
    coordinates: "Coordenadas",
    coordinatesCount: "coordenada(s)",
    actions: "Ações",
    point: "Ponto",
    route: "Rota",
    error: "Erro",
    deleteConfirmation: "Tem certeza que deseja excluir esta localidade?",
    locationName: "Nome da Localidade",
    locationNamePlaceholder: "Digite o nome da localidade",
    mapConfiguration: "Configuração do Mapa",
    save: "Salvar",
    cancel: "Cancelar",
    requiredField: "Este campo é obrigatório",
    monitoredArea: "Área Monitorada",
    monitoredLocation: "Localidade Monitorada",
    customPoint: "Ponto Selecionado",
    create: "Criar",
    createLocationButton: "Criar localidade",
    update: "Atualizar",
    saveChanges: "Salvar alterações",
    edit: "Editar",
    clear: "Limpar",
    delete: "Excluir",
    deleteLocation: "Excluir Localidade",
    drawArea: "Desenhe uma área",
    importGeojson: "Importar GeoJSON",
    dropTheFile: "Solte o arquivo aqui...",
    dragAndDrop:
      "Arraste e solte um arquivo GeoJSON aqui ou clique para navegar.",
    errorLoadingLocations: "Erro ao carregar localidades",
    errorLoadingLocation: "Erro ao carregar localidade",
    errorCreatingLocation: "Erro ao criar localidade",
    errorCreatingLocationNameInUse: "Nome da localidade já está em uso",
    errorUpdatingLocation: "Erro ao atualizar localidade",
    errorDeletingLocation: "Erro ao excluir localidade",
    errorDeletingLocationInUse:
      "Esta localidade não pode ser excluída pois está sendo usada por um alerta",
    enablePagination: "Ativar Paginação",
    noLocationsYet: "Você ainda não tem nenhuma localidade cadastrada",
    noLocationsFound: "Nenhuma localidade encontrada para o termo pesquisado",
    disablePagination: "Desativar Paginação",
    pleaseDrawAnArea:
      "* Por favor, desenhe uma área no mapa ou importe uma existente.",
    invalidArea:
      "Posicione o polígono em uma área próxima das suas estações cadastradas.",
    coordinatesRequired: "Coordenadas são obrigatórias",
    searchPlaceholder: "Buscar localidade...",
    saveGeofence: "Salvar Geofence",
  },
  event: {
    createEvent: "Criar evento",
    editEvent: "Editar evento",
    eventName: "Nome do evento",
    eventNamePlaceholder: "Ex: Risco de vento forte",
    alertName: "Nome do evento",
    exampleRisk: "Ex: Risco de vento forte",
    alertConditions: "Condições do evento",
    alertTypeChangeWarningTitle: "Atenção à mudança do tipo de evento",
    alertTypeChangeWarningDescription:
      "Ao alterar o tipo de evento, as condições serão substituídas pelas condições padrão do novo tipo. Deseja continuar?",
    alertTypeChangeChoiceDescription:
      "Ao alterar o tipo de evento, as condições também mudam. Como deseja continuar?",
    alertTypeChangeDescription:
      "Ao alterar o tipo de evento, as condições também mudam. Como deseja continuar?",
    keepCurrentConditions: "Manter minhas condições",
    useTemplateConditions: "Usar condições padrão",
    useTypeDefault: "Usar condições padrão",
    keepMyChanges: "Manter minhas condições",
    step3Preferences: "Passo 3 - Preferências",
    showInChart: "Quero ver este evento no gráfico",
    ganttSettings: "Exibir em um painel",
    wantAlerts: "Quero ser alertado da previsão",
    wantToSeeOnChart: "Quero ver este evento no gráfico",
    wantToReceiveAlerts: "Quero receber alertas",
    selectDashboard: "Vincule o evento a um painel",
    selectedDashboard: "Painel selecionado",
    selectPlaceholder: "Selecione um existente ou crie um novo",
    dashboardHelpText:
      "O evento que você está criando será exibido no painel da tela de Eventos Operacionais.",
    noDashboardWarning: 'Você ainda não tem um painel, clique em "Criar"',
    selectAlertType: "Selecione o tipo de Evento:",
    selectRiskCategory: "Selecione uma categoria de risco",
    selectRiskDescription:
      "Escolha uma opção, e vamos sugerir as condições do evento.",
    pleaseSelectRisk: "* Por favor, selecione um tipo de risco",
    pleaseAddCondition: "* Por favor, adicione pelo menos uma condição",
    aboutRisk: "Sobre o risco",
    aboutRiskGenericDescription:
      "Indica condições de risco baseadas em variáveis meteorológicas.",
    riskDescription_noCategory: "Evento sem categoria específica de risco.",
    riskDescription_extremeHeat:
      "Temperaturas muito elevadas que afetam pessoas, equipamentos e operações.",
    riskDescription_extremeWind:
      "Ventos fortes e persistentes que podem causar danos e interrupções.",
    riskDescription_extremeRain:
      "Chuva intensa em curto período, com risco de acúmulo de água.",
    riskDescription_landslide:
      "Saturação do solo causada por chuva persistente, favorecendo deslizamentos.",
    riskDescription_wildfire:
      "Condições favoráveis à propagação de fogo em áreas naturais.",
    riskDescription_treeFall:
      "Queda de árvores causada por vento forte e solo encharcado.",
    riskDescription_roofDamage:
      "Danos estruturais em telhados causados por vento intenso.",
    riskDescription_roughSea:
      "Ondas altas e mar agitado que dificultam atividades marítimas.",
    riskDescription_fog: "Formação de neblina que reduz a visibilidade.",
    riskDescription_lowVisibility:
      "Visibilidade reduzida que compromete deslocamentos e operações.",
    riskDescription_lightningStorm:
      "Tempestades com possibilidade de descargas elétricas.",
    // Risk type labels (internationalized)
    riskType: "Tipo de risco",
    riskLabel_roughSea: "Ressaca",
    riskLabel_flooding: "Alagamento",
    riskLabel_extremeWind: "Vendaval",
    riskLabel_treeFall: "Queda de\nárvores",
    riskLabel_roofDamage: "Destelha-\nmento",
    riskLabel_landslide: "Deslizamento\nde terra",
    riskLabel_extremeHeat: "Calor extremo",
    riskLabel_wildfire: "Incêndio\nflorestal",
    riskLabel_fog: "Neblina",
    riskLabel_lowVisibility: "Baixa\nvisibilidade",
    riskLabel_lightningStorm: "Incidência\nde raios",
    riskLabel_noCategory: "Sem\ncategoria",
    riskCategoryUnavailable:
      "Não disponível em sua região, entre em contato para informações.",
    notAvailable: "Não disponível",
    eventConditions: "Condições do evento",
    noConditionsAvailable:
      "Nenhuma condição disponível para este tipo de risco.",
    seeMoreRiskTypes: "Ver mais tipos de risco",
    collapseRiskOptions: "Recolher opções",
    i4castSuggestion: "Sugerido pelo i4cast",
    backToI4castSuggestion: "Voltar para sugestão i4cast",
    create: "Criar",
    save: "Salvar",
    eventAction: "Ação do evento",
    eventActionTooltip:
      "Define como as condições climáticas afetam sua operação. No modo Restritivo, as condições limitam ou impedem a operação. No modo Permissivo, as condições são necessárias para que a operação aconteça.",
    restrictive: "Restritivo",
    restrictiveTooltip:
      "Utilizado para condições climáticas que podem restringir sua operação.",
    permissive: "Permissivo",
    permissiveTooltip:
      "Utilizado para condições climáticas que permitem que sua operação aconteça.",
    color: "Cor",
    colorOnDashboard: "Cor no painel",
    eventDescriptionLabel: "Descrição",
    eventDescriptionPlaceholder: "Descreva o evento...",
    red: "Vermelho",
    orange: "Laranja",
    yellow: "Amarelo",
    blue: "Azul",
    new: "Novo",
    successEventCreated: "Evento criado com sucesso",
    eventUpdatedSuccess: "Evento atualizado com sucesso",
    eventUpdatedError: "Erro ao atualizar evento",
    errorCreatingEvent: "Erro ao criar evento",
    errorCreatingInsight: "Erro ao criar visualização do evento",
    errorCreatingAlert: "Erro ao criar alerta",
    selectAtLeastOneOption: "Selecione pelo menos uma opção",
    dashboardRequired: "Selecione um painel",
    validationError: "Erro de validação",
    cancel: "Cancelar",
    back: "Voltar",
    continue: "Continuar",
    createDashboard: "Criar painel",
    dashboardName: "Nome do painel",
    dashboardNamePlaceholder: "Digite o nome do painel",
    dashboardCreatedSuccess: "Painel criado com sucesso",
    errorCreatingDashboard: "Erro ao criar painel",
    step1Location: "Passo 1 - Localidade",
    step2Conditions: "Passo 2 - Condições",
    conditions: "Condições",
    associatedAlerts: "Alertas associados",
    nameRequired: "Nome é obrigatório",
    channelRequired: "Selecione pelo menos um canal",
    userRequired: "Selecione pelo menos um usuário",
    thisFieldRequired: "Este campo é obrigatório",
    monitoredArea: "Área monitorada",
    conditionsEmptyStateTitle:
      "Adicione uma condição climática que pode afetar sua operação",
    conditionsEmptyStateCreateButton: "Criar condição",
    conditionsEmptyStateSubtext:
      "ou selecione um risco acima e use nossas sugestões.",
  },
  validation: {
    nameRequired: "Nome do evento é obrigatório",
    atLeastOneOption:
      "Pelo menos uma opção deve ser selecionada (Evento ou Alerta)",
    locationRequired: "Uma localização monitorada deve ser selecionada",
    insightDataRequired: "Dados do evento são obrigatórios",
    dashboardRequired: "Seleção do painel é obrigatória",
    recipientsRequired: "Pelo menos um destinatário é obrigatório",
    channelsRequired: "Pelo menos um canal deve ser selecionado",
  },
};
